/*
  km-ausstattung.js · Kirchberger Metall · 14.10.2026
  Ausstattungs-Konfigurator (Regelwerk typ "ausstattung"): Überdachung Köln, Vordach Designtak, Vordach Portal (Platin).
  Zustand, Sichtbarkeit, Preis, Schrittfolge, Warenkorb, Angebotsanfrage, Galerie.

  Kein Maß: das Modell steht je Produktseite fest (genau ein Eintrag in R.modelle), der
  Kunde wählt je Schritt eine Option (Zubehör: mehrere). Preis = Grundpreis + Aufpreise -
  pauschal, je Feld (Scheibenzahl des Modells) oder je Größen-/Frachtklasse.
  Preislogik: kmAusstattungPreis unten - wortgleich mit der Cart-Transform-Function, die
  beim Checkout verbindlich aus _km_konfig nachrechnet.

  Sichtbarkeit aus dem Regelwerk: ein Schritt mit nur_wenn erscheint nur bei passender
  Vorauswahl (Siebdruck-Design nur bei Glas mit Siebdruck); eine gewählte Option kann über
  versteckt.schritte ganze Schritte und über versteckt.<schritt> einzelne Optionen ausblenden
  (Bausatz blendet die Kran-Frage und die Verdübelung aus).

  Vordach (19.09.2026, alles additiv - Köln-Regelwerke enthalten keines dieser Felder):
    R.klasse_schritt      Größenklasse (s|m|l) aus der gewählten Option dieses Schritts
                          (optionen[].klasse) statt aus modell.klasse
    option.nur_klasse     Option nur bei passender Klasse sichtbar; eine gespeicherte
                          unsichtbare Wahl fällt auf die erste sichtbare Option zurück
    option.preis_je_wahl  Preis hängt an der Wahl eines anderen Schritts (Landau: Variante)
    def.grundpreis: true  Optionen zeigen den Betrag ohne "+" (Größe = Grundpreis)
    option.farbe          Farbfeld neben dem Label (rendert das Liquid-Snippet)
    R.medien.schluessel   Galerie-Bildwechsel: Schlüssel = Wahl der genannten Schritte mit "|"
                          verbunden, Medien-Map aus custom.km_medien (wie Geländer)
    R.medien.zeichnung    Maßzeichnung "zeichnung|<groesse>": Knopf data-km-zeichnung im Größenschritt
                          schaltet die Galerie auf die Zeichnung der gewählten Größe (Zeichnungsmodus)
    R.rabatt              Aktionsrabatt in Prozent auf den Gesamtpreis (Vordach −5 %, Freigabe
                          19.09.2026): total = r2(listenpreis × 0,95), Zeile "Rabatt" wie in der
                          Function, Listenpreis als Streichpreis neben dem Gesamtpreis, in der
                          Preisliste „Aktionsrabatt −5 %“ / „−134,25 €“; Optionspreise bleiben Listenpreise

  Portal / Platin (20.09.2026, Theme V78, Function 1.19 - alles additiv, Köln/Designtak unberührt):
    def.typ "mass"        mm-Eingabe (min/max/default, max_je_wahl), Chips für die Preisstufen (def.klassen);
                          das Feld wird beim Verlassen geklemmt (kmMassWert, wie in der Function)
    grundpreis_matrix(_je_wahl), option.preis_matrix, preis_je_spalte, preis_je_qm, preis_je_stuetze,
    preis_je_seitenteil_typ, anzahl_matrix + preis_je_stueck, nur_wenn mit Listen und "!x", nur_wenn_oder,
    nur_bis, abstuetzung.zellen (Eckstützen 70x70 erzwungen - das Radio folgt p.wahl), stuetzen_inklusive,
    profil_je_breite (Info-Zeilen schritt 'info'), medien.bild_nach_typ (Bildschlüssel = option.bild_typ)

  Portal / Platin Rahmenrinnenprofil (14.10.2026, Theme V109 - additiv):
    R.profil              Profil je Zelle Tiefe x Breite (Preisklassen, aufgerundet) statt nur je Breite:
                          { key, standard, sonder, zellen: [[tiefe_klasse, breite_klasse], ...] } wie abstuetzung.zellen
                          (Preisliste Seite 12: 245 mm nur bei Tiefe 1.600 ab Breite 3.500 und Tiefe 1.800 ab 3.000,
                          Martin 08.10.2026). profil_je_breite bleibt als Altform lesbar (kmProfil).
    Zeichnung je Profil   zeichnungKey probiert zuerst "<schluessel>|<profilzahl>" (z. B. "zeichnung|ohne|245"),
                          sonst den bisherigen Schlüssel - km_medien braucht nur die zusätzlichen 245er-Einträge.
    Sternchen-Zellen      masse.abstuetzung = 1 in abstuetzung.zellen (15.10.2026): Optionen mit nur_bis {abstuetzung: 0}
                          sind dort nicht wählbar (Platin 125: einseitige Varianten); abstuetzung.ersatz ordnet die Wahl um.
    stuetzen_inklusive    zusätzlich breite_ab (VSG: Stützen ab Breite 3.001 im Preis) - Info-Zeile auch dort.

  Hochbeet (27.09.2026, Theme V90, Function 2.4 - additiv, alle anderen Familien unberührt):
    R.formel (art "hochbeet_vvhc")  Grundpreis aus der Preisformel des Lieferanten Gardomio statt Matrix
                          (kmHochbeetPreis, wortgleich Function/n8n/Rust); kmHochbeetKlemmen klemmt Oberkante,
                          Länge bei Kantung außen und Breite ≤ Länge nach der Blechwahl
    R.menge               Stückzahl-Feld km_menge: Stückpreis hängt an der Menge (Function: line.quantity),
                          Gesamtpreis = Stückpreis × Menge, Warenkorb mit quantity = Menge
    Blech/Boden-Karten    zeigen den Mehrpreis gegenüber der Mindeststärke bzw. "ohne Boden"

  Modul / Fahrradüberdachung Tia (10.10.2026, Function 2.12 - additiv, alle anderen Familien unberührt):
    R.formel (art "modul")  Grundpreis = Grundeinheit + Anbaumodul × (n − 1) + Sondermaß (kmModulKontext,
                          kmModulGrundpreis, wortgleich Function/n8n/Rust); Modulzahl aus dem Modul-Schritt oder
                          aus der Gesamtbreite (Dachbreite im Trapezblech-Raster). Optionspreise preis_je_modul
                          (+ preis_erstes), preis_je_meter, preis_je_seite, preis_je_modulzahl - Werte je Wahl
                          verschachtelbar {schritt: {wahl: wert}} (kmJeWahl)
    formel.delta_schritte Karten dieser Schritte zeigen den Mehrpreis gegenüber der ersten Option (wie Blech/Boden)
    def.skizze "tia"      parametrische Zeichnung (tiaSkizze): Vorderansicht mit Dachbreite, Stützenachsen, Höhen,
                          Fundament, Rück-/Seitenwände; Seitenansicht mit Dachtiefe und Stützenachse. Die SVG-Box
                          legt tiaSkizzen() selbst im Schritt an (kein Liquid-Eingriff).

  Warenkorb: eine Position, Property-Schlüssel = K3-Merkmalsnamen, dazu _km_konfig als
  Klartext-JSON (nicht base64: die Function dekodiert in QuickJS, dort kostet base64 zu viel).
*/
(function () {
  'use strict';

  /* ================= Preislogik (identisch in der Function) ================= */
  function findeId(list, id) { for (var i = 0; i < (list || []).length; i++) if (list[i].id === id) return list[i]; return null; }
  // Euro-Betrag im deutschen Format ohne toLocaleString - wortgleich mit Function (QuickJS) und
  // Sub-Workflow, damit die Rabattzeile ueberall zeichengleich ist: eurText(2685) = "2.685,00 €".
  // (fmt unten nutzt toLocaleString und bleibt fuer die Anzeige.)
  function eurText(x) {
    var n = Math.round(Math.abs(Number(x) || 0) * 100);
    var ganz = String(Math.floor(n / 100));
    var rest = String(n % 100);
    var t = '';
    while (ganz.length > 3) { t = '.' + ganz.slice(-3) + t; ganz = ganz.slice(0, -3); }
    return (Number(x) < 0 ? '-' : '') + ganz + t + ',' + (rest.length < 2 ? '0' + rest : rest) + ' €';
  }
  function kmModell(R) {
    var ids = Object.keys(R.modelle || {});
    if (ids.length !== 1) return null;
    var m = R.modelle[ids[0]]; var o = { id: ids[0] };
    for (var k in m) o[k] = m[k];
    return o;
  }
  // Wirksame Groessenklasse: bei R.klasse_schritt aus der gewaehlten Option (Vordach), sonst modell.klasse (Koeln)
  function kmKlasseVon(R, modell, wahl) {
    var ks = R.klasse_schritt, def = ks ? R[ks] : null;
    if (def && def.optionen) { var o = findeId(def.optionen, wahl[ks]); if (o && o.klasse) return String(o.klasse); }
    return modell.klasse;
  }
  // Option nur bei passender Klasse (nur_klasse) waehlbar; ohne nur_klasse immer
  function kmOptionSichtbar(opt, klasse) {
    if (!opt || !(opt.nur_klasse instanceof Array)) return !!opt;
    return opt.nur_klasse.indexOf(klasse) >= 0;
  }
  /* ---- Portal (Platin), Theme V78 / Function 1.19 (20.09.2026): Masse in mm, Matrix-Preise, Bedingungen
     mit Listen und Verneinung, Stueckzahlen aus Matrizen. Wortgleich mit cart_transform_run.js
     (Function) und Positionen-rechnen.js (n8n). Koeln/Designtak nutzen keines dieser Felder. ---- */
  function kmKlasseIndex(klassen, wert) {
    var w = Number(wert) || 0;
    for (var i = 0; i < (klassen || []).length; i++) if (w <= Number(klassen[i])) return i;
    return Math.max(0, (klassen || []).length - 1);
  }
  function kmMatrixWert(m, masse, feld) {
    if (!m || !m[feld]) return 0;
    var zi = kmKlasseIndex(m.zeilen_klassen, masse[m.zeilen]);
    var si = kmKlasseIndex(m.spalten_klassen, masse[m.spalten]);
    var zeile = m[feld][String(m.zeilen_klassen[zi])];
    return zeile ? Number(zeile[si] || 0) : 0;
  }
  function kmBedingung(nurWenn, wahl, oder) {
    if (!nurWenn) return true;
    var keys = Object.keys(nurWenn); if (!keys.length) return true;
    var treffer = 0;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], soll = nurWenn[k] instanceof Array ? nurWenn[k] : [nurWenn[k]], ist = wahl[k], ok = true, positiv = [];
      for (var a = 0; a < soll.length; a++) if (String(soll[a]).charAt(0) !== '!') positiv.push(soll[a]);
      if (positiv.length && positiv.indexOf(ist) < 0) ok = false;
      for (var b = 0; b < soll.length; b++) if (String(soll[b]).charAt(0) === '!' && String(soll[b]).slice(1) === ist) ok = false;
      if (ok) treffer += 1;
    }
    return oder ? treffer > 0 : treffer === keys.length;
  }
  function kmNurBis(nurBis, masse) {
    if (!nurBis) return true;
    for (var k in nurBis) if (Number(masse[k] || 0) > Number(nurBis[k])) return false;
    return true;
  }
  function kmOptionWaehlbar(opt, klasse, wahl, masse) {
    if (!kmOptionSichtbar(opt, klasse)) return false;
    if (opt.nur_wenn && !kmBedingung(opt.nur_wenn, wahl, !!opt.nur_wenn_oder)) return false;
    return kmNurBis(opt.nur_bis, masse || {});
  }
  function kmMassWert(def, roh, wahl) {
    var max = Number(def.max);
    if (def.max_je_wahl) { var s = Object.keys(def.max_je_wahl)[0], je = s ? def.max_je_wahl[s] : null; if (je && je[wahl[s]] !== undefined) max = Number(je[wahl[s]]); }
    var n = Number(roh);
    var v = (isNaN(n) || roh === null || roh === undefined || roh === '') ? Number(def['default']) : n;
    return Math.min(max, Math.max(Number(def.min), Math.round(v)));
  }
  function kmMasseLesen(R, st, wahl) {
    var masse = {};
    for (var i = 0; i < (R.schritte || []).length; i++) { var step = R.schritte[i], def = R[step]; if (def && def.typ === 'mass') masse[step] = kmMassWert(def, (st || {})[step], wahl); }
    return masse;
  }
  // Hochbeet (R.formel.art "hochbeet_vvhc", 27.09.2026): Preisformel des Lieferanten Gardomio - wortgleich mit
  // cart_transform_run.js (formelStelle, hochbeetLieferkosten, hochbeetKlemmen, hochbeetPreis), n8n und rust/lib.rs
  function kmFormelStelle(achse, x) {
    var n = achse.length; if (n < 2) return [0, 0, 0];
    var i1 = 1;
    if (x >= Number(achse[n - 1])) i1 = n - 1;
    else if (x > Number(achse[0])) while (i1 < n && x > Number(achse[i1])) i1++;
    var i0 = i1 - 1;
    return [i0, i1, (x - Number(achse[i0])) / (Number(achse[i1]) - Number(achse[i0]))];
  }
  function kmHochbeetLieferkosten(lk, L, B, H, T, q) {
    var tb = kmFormelStelle(lk.T, T), qb = kmFormelStelle(lk.Q, q);
    var dims = [kmFormelStelle(lk.L, L), kmFormelStelle(lk.B, B), kmFormelStelle(lk.H, H)], acc = 0;
    for (var a = 0; a < 2; a++) {
      for (var b = 0; b < 2; b++) {
        var t = lk.T[a ? tb[1] : tb[0]], wt = a ? tb[2] : 1 - tb[2];
        var qq = lk.Q[b ? qb[1] : qb[0]], wq = b ? qb[2] : 1 - qb[2];
        var layer = lk.w['T' + t + 'Q' + qq]; if (!layer) continue;
        for (var mask = 0; mask < 8; mask++) {
          var node = layer, w = wt * wq;
          for (var k = 0; k < 3; k++) { var hi = (mask >> (2 - k)) & 1, d = dims[k]; node = node == null ? undefined : node[hi ? d[1] : d[0]]; w *= hi ? d[2] : 1 - d[2]; }
          if (typeof node === 'number') acc += node * w;
        }
      }
    }
    return acc;
  }
  function kmHochbeetKlemmen(f, masse, wahl) {
    var t = Number(wahl.blech), mn = (f.ok_min && f.ok_min[String(wahl.blech)]) || [0, 0];
    if (masse.oberkante_breite !== undefined) {
      var okb = Math.min(Number(f.ok_max), Math.max(Number(mn[0]), Number(masse.oberkante_breite)));
      masse.oberkante_breite = okb;
      if (masse.oberkante_hoehe !== undefined) masse.oberkante_hoehe = Math.min(Math.max(Number(mn[1]), Math.round(okb / 2)), Math.max(Number(mn[1]), Number(masse.oberkante_hoehe)));
    }
    var okb2 = masse.oberkante_breite !== undefined ? masse.oberkante_breite : Number(mn[0]);
    var fk = Number(f.faktor) || 1; // mm je Eingabeeinheit der Aussenmasse (Hochbeet: 10 = cm)
    if (wahl.kantung !== undefined && wahl.kantung === f.kantung_aussen) masse.laenge = Math.min(masse.laenge, Math.floor((Number(f.laenge_max) - 2 * (okb2 - t)) / fk));
    // Holzlager (05.10.2026): paar_max statt Breite <= Laenge
    if (f.paar_max !== undefined) { if (masse.laenge > Number(f.paar_max) && masse.breite > Number(f.paar_max)) masse.breite = Number(f.paar_max); }
    else if (masse.breite > masse.laenge) masse.breite = masse.laenge;
    // L-Form (04.10.2026): Breite hoechstens kuerzerer Schenkel minus schenkel_plus
    if (f.schenkel_plus !== undefined) {
      var lmin = Math.min(Number(masse.laenge), Number(masse.laenge2));
      // U-Form (05.10.2026): dritter Schenkel; Mitte (laenge2) mindestens 2 x Breite + mitte_plus
      if (masse.laenge3 !== undefined) lmin = Math.min(lmin, Number(masse.laenge3));
      var bmax = lmin - Number(f.schenkel_plus);
      if (masse.breite > bmax) masse.breite = bmax;
      if (f.mitte_plus !== undefined) {
        var bm = Math.floor((Number(masse.laenge2) - Number(f.mitte_plus)) / 2);
        if (masse.breite > bm) masse.breite = bm;
      }
    }
  }
  function kmHochbeetPreis(f, masse, wahl, menge) {
    var fk = Number(f.faktor) || 1;
    var L = Number(masse.laenge) * fk, B = Number(masse.breite) * fk, H = Number(masse.hoehe) * fk, T = Number(wahl.blech);
    var q = Math.min(Math.max(1, Math.floor(Number(menge) || 1)), Number(f.menge_max));
    var m = f.material;
    var stahl = 2 * (H / 1000) * (L / 1000 + B / 1000) * (T / 1000) * m[0];
    var material = stahl * m[1] * m[2];
    var lang = f.lang[1] * Math.max(0, Math.max(L / 1000, B / 1000) - f.lang[0]);
    var nwp = (f.sockel + material + lang) * f.netto[0] / f.netto[1];
    if (wahl.boden === f.boden[0]) nwp *= f.boden[1];
    var lk = kmHochbeetLieferkosten(f.lk, L, B, H, T, q);
    return Number(((nwp + lk / q) * f.brutto[0] * f.brutto[1]).toFixed(2));
  }
  // Hochbeet Bausatz (R.formel.art "hochbeet_bausatz", 28.09.2026) - wortgleich mit cart_transform_run.js (formelFaktor, hochbeetBausatzPreis)
  function kmFormelFaktor(p, last) {
    if (!p || !p.length || !(last > 0)) return 1;
    if (last <= Number(p[0][0])) return Number(p[0][1]);
    for (var i = 1; i < p.length; i++) {
      if (last <= Number(p[i][0])) {
        var a0 = Number(p[i - 1][0]), f0 = Number(p[i - 1][1]), a1 = Number(p[i][0]), f1 = Number(p[i][1]);
        if (a1 === a0) return f1;
        return f0 + (last - a0) / (a1 - a0) * (f1 - f0);
      }
    }
    return Number(p[p.length - 1][1]);
  }
  function kmHochbeetBausatzPreis(f, masse, wahl, menge) {
    var fk = Number(f.faktor) || 1;
    var L = Number(masse.laenge) * fk, B = Number(masse.breite) * fk, H = Number(masse.hoehe) * fk, T = Number(wahl.blech);
    var q = Math.min(Math.max(1, Math.floor(Number(menge) || 1)), Number(f.menge_max));
    var k = f.faktoren;
    var p = kmHochbeetLieferkosten(f.lk, L, B, H, T, q) * k[0] * k[1];
    p = p * k[2];
    p = p * kmFormelFaktor(f.gross, (L + B) * H * T);
    return Number((p / q).toFixed(2));
  }
  // Hochbeet L-Form (R.formel.art "hochbeet_lform", 04.10.2026) - wortgleich mit cart_transform_run.js (hochbeetTabelle, hochbeetLformPreis)
  function kmHochbeetTabelle(lk, x, T, q) {
    var tb = kmFormelStelle(lk.T, T), qb = kmFormelStelle(lk.Q, q);
    var n = lk.D.length, dims = [], acc = 0;
    for (var k0 = 0; k0 < n; k0++) dims.push(kmFormelStelle(lk.D[k0], x[k0]));
    for (var a = 0; a < 2; a++) {
      for (var b = 0; b < 2; b++) {
        var t = lk.T[a ? tb[1] : tb[0]], wt = a ? tb[2] : 1 - tb[2];
        var qq = lk.Q[b ? qb[1] : qb[0]], wq = b ? qb[2] : 1 - qb[2];
        var layer = lk.w['T' + t + 'Q' + qq]; if (!layer) continue;
        for (var mask = 0; mask < (1 << n); mask++) {
          var node = layer, w = wt * wq;
          for (var k = 0; k < n; k++) { var hi = (mask >> (n - 1 - k)) & 1, d = dims[k]; node = node == null ? undefined : node[hi ? d[1] : d[0]]; w *= hi ? d[2] : 1 - d[2]; }
          if (typeof node === 'number') acc += node * w;
        }
      }
    }
    return acc;
  }
  function kmHochbeetLformPreis(f, masse, wahl, menge) {
    var fk = Number(f.faktor) || 1;
    var keys = f.masse || ['laenge', 'laenge2', 'breite', 'hoehe'], n = keys.length, x = [];
    for (var i0 = 0; i0 < n; i0++) x.push(Number(masse[keys[i0]]) * fk);
    if (f.tausch) { var ta = Number(f.tausch[0]), tb = Number(f.tausch[1]); if (x[tb] > x[ta]) { var th = x[ta]; x[ta] = x[tb]; x[tb] = th; } }
    var T = Number(wahl.blech);
    var q = Math.min(Math.max(1, Math.floor(Number(menge) || 1)), Number(f.menge_max));
    var xc = [], s = 1;
    for (var i = 0; i < n; i++) {
      var mn = Number(f.lk.D[i][0]), e = Number(f.exp[i]);
      xc.push(x[i] < mn ? mn : x[i]);
      if (e > 0 && x[i] < mn) s *= x[i] <= 0 ? 0 : Math.pow(x[i] / mn, e);
    }
    var p = kmHochbeetTabelle(f.lk, xc, T, q);
    if (s < 1) p *= s;
    var k2 = f.faktoren;
    p = p * k2[0] * k2[1];
    p = p * k2[2];
    var last = 0;
    for (var j = 0; j < n - 2; j++) last += x[j];
    p = p * kmFormelFaktor(f.gross, last * x[n - 1] * T);
    return Number(p.toFixed(2));
  }
  // Modul (R.formel.art "modul", 10.10.2026, Tia): wortgleich mit cart_transform_run.js (jeWahl, modulKontext, modulGrundpreis)
  function kmJeWahl(v, wahl) {
    var guard = 0;
    while (v && typeof v === 'object' && !(v instanceof Array) && guard++ < 8) {
      var keys = Object.keys(v);
      if (keys.length !== 1 || !wahl || wahl[keys[0]] === undefined) return v;
      var inner = v[keys[0]];
      if (!inner || typeof inner !== 'object' || inner instanceof Array) return v;
      v = inner[wahl[keys[0]]];
    }
    return v;
  }
  function kmModulKontext(f, wahl, masse, R) {
    var max = Math.max(1, Number(f.max) || 4), modul = f.modul || [4390, 4300];
    var n, dachbreite, sondermass = false;
    if (f.groesse && wahl[f.groesse] === f.individuell && f.breite && masse[f.breite] !== undefined) {
      var raster = f.raster || [43, 207], b = Number(masse[f.breite]);
      dachbreite = Number(raster[0]) + Math.floor((b - Number(raster[0])) / Number(raster[1])) * Number(raster[1]);
      n = Math.min(max, Math.max(1, Math.ceil(dachbreite / Number(modul[0]))));
      sondermass = true;
    } else {
      n = Math.min(max, Math.max(1, Math.floor(Number(wahl[f.module]) || 1)));
      dachbreite = Number(modul[0]) + Number(modul[1]) * (n - 1);
    }
    var seiten = 0, sd = f.seiten ? R[f.seiten] : null;
    if (sd && sd.optionen) { var so = findeId(sd.optionen, wahl[f.seiten]); seiten = so ? Number(so.seiten || 0) : 0; }
    return { n: n, dachbreite: dachbreite, sondermass: sondermass, seiten: seiten };
  }
  function kmModulGrundpreis(f, wahl, mk) {
    var g = kmJeWahl(f.grund, wahl);
    if (!(g instanceof Array) || !g.length) return 0;
    return Math.round((Number(g[0] || 0) + Number(g[1] || 0) * (mk.n - 1) + (mk.sondermass ? Number(f.sondermass || 0) : 0)) * 100) / 100;
  }
  function kmGrundpreisVon(R, modell, wahl, masse, menge, ctx) {
    if (R.formel && R.formel.art === 'modul') return kmModulGrundpreis(R.formel, wahl, (ctx && ctx.modul) || kmModulKontext(R.formel, wahl, masse, R));
    if (R.formel && R.formel.art === 'hochbeet_vvhc') return kmHochbeetPreis(R.formel, masse, wahl, menge);
    if (R.formel && R.formel.art === 'hochbeet_bausatz') return kmHochbeetBausatzPreis(R.formel, masse, wahl, menge);
    if (R.formel && R.formel.art === 'hochbeet_lform') return kmHochbeetLformPreis(R.formel, masse, wahl, menge);
    if (R.grundpreis_matrix_je_wahl) {
      var s = Object.keys(R.grundpreis_matrix_je_wahl)[0], je = R.grundpreis_matrix_je_wahl[s] || {};
      var m = je[wahl[s]] || je[Object.keys(je)[0]];
      return kmMatrixWert(m, masse, 'preise');
    }
    if (R.grundpreis_matrix) return kmMatrixWert(R.grundpreis_matrix, masse, 'preise');
    return Number(modell.grundpreis || 0);
  }
  function kmAbstuetzungNoetig(R, masse) {
    var a = R.abstuetzung; if (!a || !(a.zellen instanceof Array)) return false;
    var gm = R.grundpreis_matrix;
    if (!gm && R.grundpreis_matrix_je_wahl) { var s = Object.keys(R.grundpreis_matrix_je_wahl)[0], je = R.grundpreis_matrix_je_wahl[s]; gm = je[Object.keys(je)[0]]; }
    if (!gm) return false;
    var t = Number(gm.zeilen_klassen[kmKlasseIndex(gm.zeilen_klassen, masse[gm.zeilen])]);
    var b = Number(gm.spalten_klassen[kmKlasseIndex(gm.spalten_klassen, masse[gm.spalten])]);
    for (var i = 0; i < a.zellen.length; i++) if (Number(a.zellen[i][0]) === t && Number(a.zellen[i][1]) === b) return true;
    return false;
  }
  // Rahmenrinnenprofil (Portal Platin, 14.10.2026): je Zelle Tiefe x Breite in Preisklassen wie kmAbstuetzungNoetig.
  // R.profil.zellen = Sonderprofil (sonder), alles andere standard; ohne R.profil die Altform profil_je_breite.
  function kmProfil(R, masse, wahl) {
    var p = R.profil;
    if (p && p.zellen instanceof Array) {
      var gm = R.grundpreis_matrix;
      if (!gm && R.grundpreis_matrix_je_wahl) { var s = Object.keys(R.grundpreis_matrix_je_wahl)[0], je = R.grundpreis_matrix_je_wahl[s]; gm = (wahl && je[wahl[s]]) || je[Object.keys(je)[0]]; }
      if (!gm) return String(p.standard);
      var t = Number(gm.zeilen_klassen[kmKlasseIndex(gm.zeilen_klassen, masse[gm.zeilen])]);
      var b = Number(gm.spalten_klassen[kmKlasseIndex(gm.spalten_klassen, masse[gm.spalten])]);
      for (var i = 0; i < p.zellen.length; i++) if (Number(p.zellen[i][0]) === t && Number(p.zellen[i][1]) === b) return String(p.sonder);
      return String(p.standard);
    }
    if (R.profil_je_breite) { var pf = R.profil_je_breite; return String(pf.werte[kmKlasseIndex(pf.klassen, masse.breite)]); }
    return null;
  }
  function kmMm(v, einheit) { return String(Math.round(Number(v) || 0)) + ' ' + (einheit || 'mm'); } // Einheit des Schritts (Hochbeet: cm)
  function kmAufpreis(opt, modell, wahl, ctx) {
    if (!opt) return 0;
    if (opt.preis_je_wahl) {
      var schritt = Object.keys(opt.preis_je_wahl)[0], je = schritt ? opt.preis_je_wahl[schritt] : null;
      return Number((je && wahl && je[wahl[schritt]]) || 0);
    }
    if (opt.aufpreis_je_feld !== undefined) return Number(opt.aufpreis_je_feld) * Number(modell.felder || 0);
    if (opt.aufpreis_je_klasse) return Number(opt.aufpreis_je_klasse[modell.klasse] || 0);
    if (opt.preis_je_klasse) return Number(opt.preis_je_klasse[modell.klasse] || 0);
    if (opt.aufpreis_je_fracht_klasse) return Number(opt.aufpreis_je_fracht_klasse[modell.fracht_klasse || modell.klasse] || 0);
    if (ctx) {
      var masse = ctx.masse || {};
      if (opt.preis_matrix) return Math.round(kmMatrixWert(opt.preis_matrix, masse, 'preise') * Number(opt.anzahl || 1) * 100) / 100;
      if (opt.preis_je_spalte) { var sp = opt.preis_je_spalte; return Number((sp.preise || [])[kmKlasseIndex(sp.spalten_klassen, masse[sp.spalten])] || 0); }
      if (opt.preis_je_qm !== undefined) return Math.round(Number(opt.preis_je_qm) * Number((ctx.flaechen || {})[opt.flaeche || 'dach'] || 0) * 100) / 100;
      if (opt.preis_je_stuetze !== undefined) return Math.round(Number(opt.preis_je_stuetze) * Number(ctx.stuetzen || 0) * 100) / 100;
      if (opt.preis_je_seitenteil_typ) { var sum = 0; for (var i = 0; i < (opt.seiten || []).length; i++) sum += Number(opt.preis_je_seitenteil_typ[(ctx.typen || {})[opt.seiten[i]]] || 0); return Math.round(sum * 100) / 100; }
      if (opt.preis_je_stueck !== undefined) { var menge = Number((ctx.mengen || {})[opt.menge_von || ctx.schritt] || 0); return Math.round((Number(opt.preis_je_stueck) * menge + Number(opt.zusatz_fest || 0)) * 100) / 100; }
      // Modul (Tia): Preise nach Modulzahl, Dachbreite und Seitenzahl - Werte je Wahl verschachtelbar (kmJeWahl)
      if (ctx.modul) {
        var mk = ctx.modul;
        if (opt.preis_je_modul !== undefined) {
          var jm = Number(kmJeWahl(opt.preis_je_modul, wahl) || 0);
          if (opt.preis_erstes !== undefined) return Math.round((Number(kmJeWahl(opt.preis_erstes, wahl) || 0) + jm * (mk.n - 1)) * 100) / 100;
          return Math.round(jm * mk.n * 100) / 100;
        }
        if (opt.preis_je_meter) {
          var pm = kmJeWahl(opt.preis_je_meter, wahl) || {}, rund = Number(pm.rundung || 1000);
          return Math.round(Number(pm.preis || 0) * Math.ceil(mk.dachbreite / rund) * rund / 1000 * 100) / 100;
        }
        if (opt.preis_je_seite !== undefined) return Math.round(Number(kmJeWahl(opt.preis_je_seite, wahl) || 0) * mk.seiten * 100) / 100;
        if (opt.preis_je_modulzahl) {
          var tz = kmJeWahl(opt.preis_je_modulzahl, wahl);
          if (tz instanceof Array && tz.length) return Number(tz[Math.min(tz.length, mk.n) - 1] || 0);
          return 0;
        }
      }
    }
    return Number(opt.aufpreis || opt.preis || 0);
  }
  // Anzeigename je Groessenklasse (Zubehoer: Fahrradstaender-Variante nach Breite der Ueberdachung)
  function kmLabel(opt, modell) { return (opt && opt.label_je_klasse && opt.label_je_klasse[modell.klasse]) ? String(opt.label_je_klasse[modell.klasse]) : (opt ? String(opt.label) : ''); }
  function kmSichtbar(R, wahl, masse) {
    var aus = {}, sicht = {}, i, step, def, o, j;
    for (i = 0; i < (R.schritte || []).length; i++) {
      step = R.schritte[i]; def = R[step];
      if (!def || !def.optionen) continue;
      o = findeId(def.optionen, wahl[step]);
      if (o && o.versteckt && o.versteckt.schritte) for (j = 0; j < o.versteckt.schritte.length; j++) aus[o.versteckt.schritte[j]] = true;
    }
    for (i = 0; i < (R.schritte || []).length; i++) {
      step = R.schritte[i]; def = R[step];
      if (aus[step]) continue;
      if (def && def.nur_wenn && !kmBedingung(def.nur_wenn, wahl, !!def.nur_wenn_oder)) continue;
      if (def && def.nur_bis && !kmNurBis(def.nur_bis, masse || {})) continue;
      sicht[step] = true;
    }
    return sicht;
  }
  // Optionen, die eine andere gewählte Option ausblendet: { schritt: { optionId: true } }
  function kmVersteckteOptionen(R, wahl) {
    var v = {};
    for (var i = 0; i < (R.schritte || []).length; i++) {
      var step = R.schritte[i], def = R[step];
      if (!def || !def.optionen) continue;
      var o = findeId(def.optionen, wahl[step]);
      if (!o || !o.versteckt) continue;
      for (var ziel in o.versteckt) {
        if (ziel === 'schritte') continue;
        v[ziel] = v[ziel] || {};
        for (var j = 0; j < o.versteckt[ziel].length; j++) v[ziel][o.versteckt[ziel][j]] = true;
      }
    }
    return v;
  }
  function kmAusstattungPreis(R, st, menge) {
    var modell = kmModell(R); if (!modell) return null;
    var wahl = {}, uebernommen = {}, i, step, def, e, runde;
    for (i = 0; i < (R.schritte || []).length; i++) {
      step = R.schritte[i]; def = R[step];
      if (!def || !def.optionen || def.mehrfach) continue;
      var g = findeId(def.optionen, st[step]);
      wahl[step] = g ? g.id : def.optionen[0].id;
    }
    var masse = kmMasseLesen(R, st, wahl);
    // Sternchen-Zellen (15.10.2026): Pseudo-Mass fuer nur_bis {abstuetzung: 0} - Option nur ohne Abstuetzungspflicht
    masse.abstuetzung = kmAbstuetzungNoetig(R, masse) ? 1 : 0;
    // Klasse aus der Wahl (klasse_schritt), dann nur_klasse/nur_wenn/nur_bis aufloesen: unsichtbare Wahl -> erste sichtbare Option
    // (zwei Durchlaeufe: eine Rueckfallwahl kann die Bedingung einer spaeteren Option aendern)
    modell.klasse = kmKlasseVon(R, modell, wahl);
    // abstuetzung.ersatz {schritt: {von: nach}} (Portal 20.09.2026): bei Abstuetzungspflicht die Auswahl "freitragend"
    // auf "Stuetze beidseits" - das Radio folgt p.wahl (sichtbarkeit), gleiche Regel wie in der Function
    if (R.abstuetzung && R.abstuetzung.ersatz && kmAbstuetzungNoetig(R, masse)) {
      for (var es in R.abstuetzung.ersatz) {
        var em = R.abstuetzung.ersatz[es];
        if (em && wahl[es] !== undefined && em[wahl[es]] !== undefined) wahl[es] = em[wahl[es]];
      }
    }
    for (runde = 0; runde < 2; runde++) {
      for (i = 0; i < (R.schritte || []).length; i++) {
        step = R.schritte[i]; def = R[step];
        if (step === R.klasse_schritt || !def || !def.optionen || def.mehrfach) continue;
        // uebernimmt {von, nur_wenn}: Wahl eines anderen Schritts uebernehmen (Portal 20.09.2026: "Seitenteil rechts
        // und links" = eine Ausfuehrung fuer beide Seiten; der Schritt bleibt fuer den Preis sichtbar, sichtbarkeit()
        // blendet ihn aus und zieht das Radio nach) - gleiche Regel wie in der Function
        if (def.uebernimmt && def.uebernimmt.von && kmBedingung(def.uebernimmt.nur_wenn, wahl, !!def.uebernimmt.nur_wenn_oder)) {
          if (wahl[def.uebernimmt.von] !== undefined) wahl[step] = wahl[def.uebernimmt.von];
          uebernommen[step] = true;
          continue;
        }
        var gw = findeId(def.optionen, wahl[step]);
        if (gw && kmOptionWaehlbar(gw, modell.klasse, wahl, masse)) continue;
        var erste = null;
        for (e = 0; e < def.optionen.length; e++) if (kmOptionWaehlbar(def.optionen[e], modell.klasse, wahl, masse)) { erste = def.optionen[e]; break; }
        wahl[step] = (erste || def.optionen[0]).id;
      }
    }
    // Abstuetzung Pflicht (Sternchen-Zellen): ohne Seitenteil und ohne Eckstuetze -> beide Eckstuetzen auf den Standard
    if (kmAbstuetzungNoetig(R, masse)) {
      var sl = wahl.seitenteil_links || 'ohne', sr = wahl.seitenteil_rechts || 'ohne', std = (R.abstuetzung && R.abstuetzung.standard) || '70x70';
      if (sl === 'ohne' && sr === 'ohne' && (wahl.eckstuetze_links || 'ohne') === 'ohne' && (wahl.eckstuetze_rechts || 'ohne') === 'ohne') {
        if (R.eckstuetze_links && findeId(R.eckstuetze_links.optionen, std)) wahl.eckstuetze_links = std;
        if (R.eckstuetze_rechts && findeId(R.eckstuetze_rechts.optionen, std)) wahl.eckstuetze_rechts = std;
      }
    }
    // Hochbeet: Oberkante, Laenge bei Kantung aussen und Breite <= Laenge erst nach der Blechwahl klemmen
    if (R.formel && (R.formel.art === 'hochbeet_vvhc' || R.formel.art === 'hochbeet_bausatz' || R.formel.art === 'hochbeet_lform')) kmHochbeetKlemmen(R.formel, masse, wahl);
    var sicht = kmSichtbar(R, wahl, masse);
    // Kontext fuer Portal-Preise: Seitenteiltypen je Seite, Stuetzenzahl, Flaechen, Stueckzahlen aus Matrizen
    var typen = {}, stuetzen = 0, flaechen = { dach: Math.round(Number(masse.breite || 0) * Number(masse.tiefe || 0) / 1e4) / 100, seitenteil_glas: 0 };
    ['links', 'rechts'].forEach(function (seite) {
      var sstep = 'seitenteil_' + seite, sdef = R[sstep]; if (!sdef || !sicht[sstep]) return;
      var so = findeId(sdef.optionen, wahl[sstep]); if (!so || so.id === 'ohne') return;
      typen[seite] = so.id; stuetzen += Number(so.stuetzen || 0);
      if (so.art === 'glas') flaechen.seitenteil_glas = Math.round((flaechen.seitenteil_glas + Number(masse.tiefe || 0) * Number(masse.hoehe_seitenteil || 0) / 1e6) * 100) / 100;
    });
    var mengen = {};
    for (i = 0; i < (R.schritte || []).length; i++) { def = R[R.schritte[i]]; if (def && def.anzahl_matrix) mengen[R.schritte[i]] = kmMatrixWert(def.anzahl_matrix, masse, 'anzahl'); }
    var ctx = { masse: masse, typen: typen, stuetzen: stuetzen, flaechen: flaechen, mengen: mengen, schritt: '' };
    // Modul (Tia): Modulzahl, Dachbreite, Seitenzahl - Grundlage fuer Grundpreis und Optionspreise
    var fm = R.formel && R.formel.art === 'modul' ? R.formel : null;
    if (fm) ctx.modul = kmModulKontext(fm, wahl, masse, R);
    var grund = kmGrundpreisVon(R, modell, wahl, masse, menge, ctx);
    var total = grund;
    var zeilen = [{ key: R.familie_key || 'Modell', label: 'Modell', value: modell.label, betrag: grund, schritt: 'modell' }];
    // Modul: Info-Zeilen hinter dem Modul- bzw. Breitenschritt (Dachbreite immer; Module und Sondermass bei individueller Breite)
    function modulZeilen(step) {
      if (!fm || !ctx.modul || (step !== fm.module && step !== fm.breite)) return;
      var mk = ctx.modul, z = fm.zeilen || {};
      zeilen.push({ key: z.dachbreite || 'Dachbreite', label: z.dachbreite || 'Dachbreite', value: kmMm(mk.dachbreite, 'mm'), betrag: 0, schritt: 'info' });
      if (step === fm.breite) {
        zeilen.push({ key: z.module || 'Module', label: z.module || 'Module', value: String(mk.n) + (mk.n > 1 ? ' (Grundeinheit + ' + (mk.n - 1) + ' Anbaumodul' + (mk.n > 2 ? 'e' : '') + ')' : ' (Grundeinheit)'), betrag: 0, schritt: 'info' });
        if (mk.sondermass) zeilen.push({ key: z.sondermass || 'Sondermaß', label: z.sondermass || 'Sondermaß', value: 'individuelle Breite', betrag: 0, schritt: 'info' });
      }
    }
    for (i = 0; i < (R.schritte || []).length; i++) {
      step = R.schritte[i]; def = R[step];
      if (!def || !sicht[step]) continue;
      ctx.schritt = step;
      if (def.typ === 'mass') {
        zeilen.push({ key: def.key, label: def.zeile || def.label, value: kmMm(masse[step], def.einheit), betrag: 0, schritt: step });
        modulZeilen(step);
        if (step === 'breite') { var pv = kmProfil(R, masse, wahl); if (pv) { var pk = (R.profil || R.profil_je_breite).key; zeilen.push({ key: pk, label: pk, value: pv, betrag: 0, schritt: 'info' }); wahl.profil = pv.replace(/\D/g, ''); } }
        if (step === 'tiefe' && R.stuetzen_inklusive && (Number(masse.tiefe) >= Number(R.stuetzen_inklusive.tiefe_ab) || (R.stuetzen_inklusive.breite_ab && Number(masse.breite) >= Number(R.stuetzen_inklusive.breite_ab))) && kmBedingung(R.stuetzen_inklusive.nur_wenn, wahl, false)) {
          zeilen.push({ key: R.stuetzen_inklusive.key || 'Stützen', label: R.stuetzen_inklusive.key || 'Stützen', value: String(R.stuetzen_inklusive.text), betrag: 0, schritt: 'info' });
        }
      } else if (def.mehrfach && def.optionen) {
        // Auswahl als Liste von IDs (je 1 Stueck) oder als Objekt { id: Stueckzahl }
        var sel = st[step], paare = [], n = 0, max = Number(def.menge_max || 10);
        if (sel instanceof Array) { for (var a = 0; a < sel.length; a++) paare.push([sel[a], 1]); }
        else if (sel && typeof sel === 'object') { for (var k in sel) paare.push([k, sel[k]]); }
        for (var zz = 0; zz < paare.length; zz++) {
          var zo = findeId(def.optionen, paare[zz][0]); if (!zo) continue;
          var menge = Math.min(max, Math.max(0, Math.floor(Number(paare[zz][1]) || 0))); if (menge < 1) continue;
          if (!kmOptionWaehlbar(zo, modell.klasse, wahl, masse)) continue;
          n += 1; var zp = kmAufpreis(zo, modell, wahl, ctx) * menge; total += zp;
          zeilen.push({ key: def.key + ' #' + n, label: def.zeile || def.label, value: (menge > 1 ? menge + ' × ' : '') + kmLabel(zo, modell), betrag: zp, schritt: step });
        }
      } else if (def.optionen) {
        var o = findeId(def.optionen, wahl[step]); var p = kmAufpreis(o, modell, wahl, ctx); total += p;
        var text = kmLabel(o, modell);
        // wahl: freie Eingabe (Sonderfarbe RAL/DB nach Wahl). Text im Zustand unter "<schritt>_wunsch",
        // wortgleich mit der Function und dem Gelaender: "<Text> (Wunschfarbe)".
        if (o && o.wahl) { var wt = st[step + '_wunsch'] != null ? String(st[step + '_wunsch']).replace(/^\s+|\s+$/g, '') : ''; if (wt) text = wt + ' (Wunschfarbe)'; }
        if (def.anzahl_matrix && mengen[step]) text = mengen[step] + ' × ' + text;
        // leer: abgewaehlte Option ("ohne ...", 0 EUR) - bleibt in den Warenkorb-Eigenschaften, wird in der Zusammenfassung nicht gezeigt
        zeilen.push({ key: def.key, label: def.zeile || def.label, value: text, betrag: p, schritt: step, leer: !!(o && o.id === 'ohne' && /^ohne\b/i.test(text) && !(p > 0)) });
        modulZeilen(step);
      } else if (def.typ === 'text' || step === 'bemerkung') {
        var t = st[step] != null ? String(st[step]).replace(/^\s+|\s+$/g, '') : '';
        if (t) zeilen.push({ key: def.key, label: def.zeile || def.label, value: t, betrag: 0, schritt: step });
        else if (def['default']) zeilen.push({ key: def.key, label: def.zeile || def.label, value: String(def['default']), betrag: 0, schritt: step });
      }
    }
    // Aktionsrabatt (R.rabatt, Vordach -5 %): prozentual auf den Gesamtpreis, Listenpreis bleibt als Streichpreis erhalten.
    // schritt 'rabatt' gehoert zu keinem Schritt der Seite (wie 'modell'): wertText/schritteZeichnen finden dazu keinen .km-step.
    var listenpreis = Math.round(total * 100) / 100;
    var rabattProzent = 0;
    total = listenpreis;
    if (R.rabatt && Number(R.rabatt.prozent) > 0) {
      rabattProzent = Number(R.rabatt.prozent);
      total = Math.round(listenpreis * (1 - rabattProzent / 100) * 100) / 100;
      zeilen.push({ key: R.rabatt.key || 'Rabatt', label: R.rabatt.label || R.rabatt.key || 'Rabatt', value: '−' + rabattProzent + ' % (Listenpreis ' + eurText(listenpreis) + ')', betrag: -(listenpreis - total), schritt: 'rabatt' });
    }
    return { total: total, listenpreis: listenpreis, rabatt_prozent: rabattProzent, zeilen: zeilen, wahl: wahl, masse: masse, sicht: sicht, uebernommen: uebernommen, modell: modell, klasse: modell.klasse, ctx: ctx };
  }

  /* ================= Seite ================= */
  function init(root) {
    var sid = root.getAttribute('data-section-id');
    var rulesEl = document.getElementById('km-rules-' + sid);
    var ctxEl = document.getElementById('km-ctx-' + sid);
    var imgEl = document.getElementById('km-images-' + sid);
    var form = document.getElementById('km-form-' + sid);
    if (!rulesEl || !ctxEl || !form) return;
    var R = JSON.parse(rulesEl.textContent);
    var CTX = JSON.parse(ctxEl.textContent);
    var MODELL = kmModell(R);
    // Medien-Map (custom.km_medien, Vordach): "<wahl>|<wahl>|…" -> Medien-ID; media_url je Medien-ID.
    // Kommt wie beim Gelaender aus km-images-<id>, ersatzweise aus CTX.media. Ohne R.medien bleibt die Galerie unberuehrt (Koeln).
    var IMG = (function () { try { return imgEl ? JSON.parse(imgEl.textContent) : {}; } catch (e) { return {}; } })();
    var MEDIA = IMG.media || CTX.media || {};
    var MEDIA_URL = IMG.media_url || CTX.media_url || {};
    // Galeriebild je Option (Köln, 16.10.2026): km-galerie-opt-<id> = {"holz": Medien-ID}; die Liquid-Datei
    // sucht das Produktmedium mit "Holzverkleidung" im Alt-Text. Ohne Treffer null - dann kein Sprung.
    var GAL_OPT = (function () { var el = document.getElementById('km-galerie-opt-' + sid); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } })();
    var SCHRITTE = (R.schritte || []).filter(function (s) { return s !== 'bemerkung' && R[s]; });

    var TAXF = (function () {
      var st = R.steuer; if (!st || !st.saetze || !CTX.country) return 1;
      var satz = st.saetze[CTX.country]; if (satz === undefined || satz === null) return 1;
      return (100 + Number(satz)) / (100 + Number(st.basissatz || 19));
    })();
    var TAXSATZ = (function () {
      var st = R.steuer; if (!st || !st.saetze || !CTX.country) return null;
      var satz = st.saetze[CTX.country]; return (satz === undefined || satz === null) ? null : Number(satz);
    })();

    var els = {
      total: document.getElementById('km-total-' + sid),
      streich: document.getElementById('km-streich-' + sid),
      netto: document.getElementById('km-netto-' + sid),
      liste: document.getElementById('km-liste-' + sid),
      flag: document.getElementById('km-flag-' + sid),
      add: document.getElementById('km-add-' + sid),
      quote: document.getElementById('km-quote-' + sid),
      msg: document.getElementById('km-msg-' + sid),
      offen: document.getElementById('km-offen-' + sid),
      leiste: document.getElementById('km-fortschritt-' + sid)
    };

    function fmt(n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function fmtMm(n) { return Number(n).toLocaleString('de-DE'); }
    // Stueckzahl (R.menge, Hochbeet 27.09.2026): Feld km_menge im Formular; der Stueckpreis der Formel haengt daran
    // (Function: line.quantity). Ohne R.menge immer 1 - Koeln, Designtak und Portal bleiben unveraendert.
    function menge() {
      if (!R.menge) return 1;
      var el = form.elements['km_menge'], n = Math.floor(Number(el && el.value) || 1);
      return Math.min(Number(R.menge.max || 99), Math.max(1, n));
    }
    var FORMEL = R.formel && (R.formel.art === 'hochbeet_vvhc' || R.formel.art === 'hochbeet_bausatz' || R.formel.art === 'hochbeet_lform' || R.formel.art === 'modul') ? R.formel : null;
    var MODUL = FORMEL && FORMEL.art === 'modul'; // Tia: Modulzahl-Formel (eigene Skizze, keine Hochbeet-Klemmregeln)
    // Portal: Massfeld beim Verlassen auf min/max/Ganzzahl klemmen (kmMassWert - dieselbe Klemmung wie in der Function)
    function masseKlemmen() {
      var st = state(), p = kmAusstattungPreis(R, st, menge()); if (!p) return;
      for (var i = 0; i < SCHRITTE.length; i++) {
        var step = SCHRITTE[i], def = R[step]; if (!def || def.typ !== 'mass') continue;
        var mf = form.elements[step]; if (!mf) continue;
        if (String(mf.value) !== String(p.masse[step])) mf.value = p.masse[step];
      }
    }
    function wert(name) {
      var el = form.elements[name]; if (!el) return '';
      if (el.length && el[0] && el[0].type === 'radio') { for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value; return ''; }
      return el.value;
    }
    function werte(name) {
      var out = [], el = form.elements[name]; if (!el) return out;
      var list = el.length && !el.tagName ? el : [el];
      for (var i = 0; i < list.length; i++) if (list[i].checked) out.push(list[i].value);
      return out;
    }
    function setWert(name, v) {
      var el = form.elements[name]; if (!el || v == null) return;
      if (el.length && el[0] && el[0].type === 'radio') {
        var treffer = false; for (var i = 0; i < el.length; i++) if (el[i].value === String(v)) treffer = true;
        if (!treffer) return;
        for (var j = 0; j < el.length; j++) el[j].checked = (el[j].value === String(v));
      } else if (el.length && el[0] && el[0].type === 'checkbox') {
        var ids = v instanceof Array ? v : (v && typeof v === 'object' ? Object.keys(v) : []);
        for (var k = 0; k < el.length; k++) {
          el[k].checked = ids.indexOf(el[k].value) >= 0;
          var mf = form.elements[name + '_n_' + el[k].value];
          if (mf && !(v instanceof Array) && v && v[el[k].value]) mf.value = v[el[k].value];
        }
      } else el.value = v;
    }

    // Zustand = Schrittname → Options-ID (Zubehör: Liste, Text: String), plus bemerkung
    // Option mit freier Eingabe (wahl: true) - gibt die Option zurueck oder null
    function wahlOption(def) {
      if (!def || !def.optionen) return null;
      for (var i = 0; i < def.optionen.length; i++) if (def.optionen[i].wahl) return def.optionen[i];
      return null;
    }

    function state() {
      var s = { t: 'ausstattung' };
      for (var i = 0; i < SCHRITTE.length; i++) {
        var step = SCHRITTE[i], def = R[step];
        if (def.mehrfach) {
          if (def.menge) {
            var ids = werte(step), map = {};
            for (var m = 0; m < ids.length; m++) { var mf = form.elements[step + '_n_' + ids[m]]; map[ids[m]] = mf ? Number(mf.value) || 1 : 1; }
            s[step] = map;
          } else s[step] = werte(step);
        }
        else if (def.typ === 'text') s[step] = String(wert(step) || '').replace(/^\s+|\s+$/g, '');
        else if (def.typ === 'mass') { var mv = String(wert(step) || '').replace(/^\s+|\s+$/g, ''); s[step] = mv === '' ? '' : Number(mv.replace(',', '.')); } // Portal: mm-Eingabe; leer -> Standardmass in kmMassWert
        else s[step] = wert(step);
      }
      // Freie Eingabe je Schritt (Option mit wahl: true, z. B. Sonderfarbe RAL nach Wahl)
      for (var w = 0; w < SCHRITTE.length; w++) { var ws = SCHRITTE[w]; if (wahlOption(R[ws])) s[ws + '_wunsch'] = String(wert(ws + '_wunsch') || '').replace(/^\s+|\s+$/g, ''); }
      if (R.bemerkung) s.bemerkung = String(wert('bemerkung') || '').replace(/^\s+|\s+$/g, '');
      return s;
    }

    // Aufpreise in die Karten schreiben - je Modell und je Wahl verschieden (Feldzahl, Klasse,
    // preis_je_wahl). Laeuft in update(): die Klasse haengt beim Vordach an der gewaehlten Groesse.
    // Bei def.grundpreis === true steht der Betrag ohne "+" (die Groesse IST der Grundpreis).
    function optionPreise(wahl, modell, ctx) {
      modell = modell || MODELL; wahl = wahl || {};
      // Hochbeet: Blech und Boden stecken im Formelpreis - die Karte zeigt den Mehrpreis gegenueber der ersten
      // waehlbaren Option des Schritts (Mindest-Blechstaerke bzw. ohne Boden), gerechnet mit der aktuellen Auswahl
      var formelDelta = null;
      if (FORMEL && ctx) {
        formelDelta = {};
        var sf = state(), mf = menge();
        (FORMEL.delta_schritte || ['blech', 'boden']).forEach(function (fs) {
          var fd = R[fs]; if (!fd || !fd.optionen) return;
          var basis = null, werte = {};
          for (var fi = 0; fi < fd.optionen.length; fi++) {
            var fo = fd.optionen[fi];
            if (!kmOptionWaehlbar(fo, modell && modell.klasse, wahl, ctx.masse)) continue;
            var s2 = {}; for (var kk in sf) s2[kk] = sf[kk]; s2[fs] = fo.id;
            var pr = kmAusstattungPreis(R, s2, mf); if (!pr) continue;
            if (basis === null) basis = pr.total;
            werte[fo.id] = Math.round((pr.total - basis) * 100) / 100;
          }
          formelDelta[fs] = werte;
        });
      }
      // Portal: ctx aus kmAusstattungPreis (Masse, Seitenteiltypen, Stuetzen, Flaechen, Mengen); ctx.schritt je Option setzen (preis_je_stueck)
      function ctxFuer(step) { if (!ctx) return null; return { masse: ctx.masse, typen: ctx.typen, stuetzen: ctx.stuetzen, flaechen: ctx.flaechen, mengen: ctx.mengen, schritt: step }; }
      // Schritte, deren Wahl ein anderer Schritt gerade uebernimmt (Portal "Seitenteil beidseits": rechts = links):
      // die Karte zeigt dann beide Seiten (bild_beide) und den Preis fuer beide Seiten (Martin 20.09.2026)
      var mal = {};
      SCHRITTE.forEach(function (t) { var u = R[t] && R[t].uebernimmt; if (u && u.von && kmBedingung(u.nur_wenn, wahl, !!u.nur_wenn_oder)) mal[u.von] = (mal[u.von] || 1) + 1; });
      root.querySelectorAll('[data-optlabel]').forEach(function (el) {
        var t = el.getAttribute('data-optlabel').split(':'), def = R[t[0]];
        var o = def ? findeId(def.optionen, t[1]) : null;
        if (o && modell) el.textContent = kmLabel(o, modell);
        var card = el.closest('.km-card'), img = card ? card.querySelector('.km-card__photo') : null;
        if (img && o) { var soll = (mal[t[0]] && o.bild_beide) ? o.bild_beide : o.bild; if (soll && img.getAttribute('src') !== soll) img.setAttribute('src', soll); }
      });
      root.querySelectorAll('[data-optpreis]').forEach(function (el) {
        var t = el.getAttribute('data-optpreis').split(':'), def = R[t[0]];
        var o = def ? findeId(def.optionen, t[1]) : null;
        var p = (o && modell) ? kmAufpreis(o, modell, wahl, ctxFuer(t[0])) * (mal[t[0]] || 1) : 0;
        if (formelDelta && formelDelta[t[0]] && o) p = formelDelta[t[0]][o.id] || 0;
        var f = Math.round(p * TAXF * 100) / 100;
        el.textContent = p > 0 ? ((def && def.grundpreis === true) ? fmt(f) : '+ ' + fmt(f)) : '';
        if (p > 0 && o && o.aufpreis_je_feld !== undefined && modell && modell.felder) el.textContent += ' (' + modell.felder + ' Felder)';
      });
    }

    // Schritte und Optionen ein-/ausblenden; versteckte gewählte Option → erste sichtbare.
    // Ausblenden: versteckt.<schritt> einer gewählten Option (Köln) oder nur_klasse gegen die
    // aktuelle Klasse (Vordach) - Karte hidden, Input disabled. Die Preislogik hat dieselbe
    // Auflösung (p.wahl), das Radio wird daran nachgezogen.
    function sichtbarkeit(s) {
      var p = kmAusstattungPreis(R, s, menge()); if (!p) return;
      var versteckt = kmVersteckteOptionen(R, p.wahl);
      var geaendert = false;
      SCHRITTE.forEach(function (step) {
        var sec = root.querySelector('.km-step[data-step="' + step + '"]'); if (!sec) return;
        sec.hidden = !p.sicht[step] || !!(p.uebernommen && p.uebernommen[step]);
        var def = R[step];
        // Skizze im Schritt nur bei passender Wahl (Portal: Entwaesserungs-Positionen 7-12 nur bei "nach unten")
        if (def.bild && def.bild_nur_wenn) { var sk = sec.querySelector('.km-f__skizze'); if (sk) sk.hidden = !kmBedingung(def.bild_nur_wenn, p.wahl, !!def.bild_nur_wenn_oder); }
        // Freie Eingabe (Sonderfarbe RAL/DB) nur zeigen, wenn die zugehoerige Option gewaehlt ist
        var wo2 = wahlOption(def);
        if (wo2) { var wf = sec.querySelector('[data-wunsch]'); if (wf) wf.hidden = p.wahl[step] !== wo2.id; }
        // Parametrische Skizze (Portal 22.09.2026): Positionen, die zur Auswahl passen, hell; die gewaehlte hervorgehoben.
        if (def.skizze && def.optionen) {
          var frei = {}, gpos = '';
          for (var qi = 0; qi < def.optionen.length; qi++) {
            var qo = def.optionen[qi]; if (qo.pos === undefined) continue;
            if (!kmOptionWaehlbar(qo, p.klasse, p.wahl, p.masse)) continue;
            frei[qo.pos] = true; if (qo.id === p.wahl[step]) gpos = String(qo.pos);
          }
          var gr = sec.querySelectorAll('[data-pos]');
          for (var gi = 0; gi < gr.length; gi++) {
            var gp = gr[gi].getAttribute('data-pos');
            gr[gi].setAttribute('class', 'km-skz__pos' + (frei[gp] ? ' is-frei' : '') + (gp === gpos ? ' is-gewaehlt' : ''));
          }
        }
        if (def.typ === 'mass') {
          // Portal: Grenzen am Feld nachfuehren (max_je_wahl: Tiefe haengt am Paneel), Schnellwahl-Chips ausserhalb der Grenzen verstecken
          var mf = form.elements[step]; if (!mf) return;
          var mx = Number(def.max); if (def.max_je_wahl) { var mjs = Object.keys(def.max_je_wahl)[0], mje = mjs ? def.max_je_wahl[mjs] : null; if (mje && mje[p.wahl[mjs]] !== undefined) mx = Number(mje[p.wahl[mjs]]); }
          if (String(mf.getAttribute('max')) !== String(mx)) mf.setAttribute('max', mx);
          if (FORMEL && !MODUL) formelGrenzen(p);
          var bereich = sec.querySelector('[data-km-bereich]'); if (bereich) bereich.textContent = fmtMm(def.min) + ' bis ' + fmtMm(mx) + ' mm';
          sec.querySelectorAll('[data-km-chip]').forEach(function (c) { var cv = Number(c.getAttribute('data-km-chip')); c.hidden = cv > mx || cv < Number(def.min); c.classList.toggle('is-aktiv', cv === Number(p.masse[step])); });
          return;
        }
        if (!def.optionen) return;
        var vs = versteckt[step] || {};
        var inputs = sec.querySelectorAll('input[name="' + step + '"]');
        var ersteSichtbare = null, gewaehltVersteckt = false, soll = null, keineWahl = !def.mehrfach;
        inputs.forEach(function (inp) {
          var card = inp.closest('.km-card');
          var weg = !!vs[inp.value] || (step !== R.klasse_schritt && !kmOptionWaehlbar(findeId(def.optionen, inp.value), p.klasse, p.wahl, p.masse));
          if (card) card.hidden = weg;
          inp.disabled = weg;
          if (!weg && !ersteSichtbare) ersteSichtbare = inp;
          if (!weg && !def.mehrfach && inp.value === p.wahl[step]) soll = inp;
          if (weg && inp.checked) { inp.checked = false; gewaehltVersteckt = true; }
          else if (inp.checked) keineWahl = false;
        });
        // Gewaehlte Option versteckt (oder gar keine gewaehlt): Radio auf die Option der Preislogik setzen.
        // Portal: auch wenn die Preislogik die Wahl zwingt (Abstuetzung -> Eckstuetzen 70x70) folgt das Radio p.wahl.
        if (!def.mehrfach && (gewaehltVersteckt || keineWahl || (soll && !soll.checked))) { var ziel = soll || ersteSichtbare; if (ziel && !ziel.checked) { for (var q = 0; q < inputs.length; q++) inputs[q].checked = false; ziel.checked = true; geaendert = true; } }
        if (def.mehrfach && def.menge) inputs.forEach(function (inp) {
          var mf = form.elements[step + '_n_' + inp.value]; if (!mf) return;
          var box = mf.closest('.km-card__menge'); if (box) box.hidden = !inp.checked;
          if (inp.checked) { var mx = Number(def.menge_max || 10), nv = Math.floor(Number(mf.value) || 1); if (nv < 1) nv = 1; if (nv > mx) nv = mx; if (String(nv) !== mf.value) mf.value = nv; }
        });
      });
      return geaendert;
    }

    // Hochbeet: min/max der Massfelder nach den Klemmregeln der Formel (Anzeige; verbindlich klemmt kmHochbeetKlemmen)
    function formelGrenzen(p) {
      var t = Number(p.wahl.blech), mn = (FORMEL.ok_min && FORMEL.ok_min[String(p.wahl.blech)]) || null;
      function setze(name, min, max) {
        var el = form.elements[name]; if (!el) return;
        if (min !== null && String(el.getAttribute('min')) !== String(min)) el.setAttribute('min', min);
        if (max !== null && String(el.getAttribute('max')) !== String(max)) el.setAttribute('max', max);
      }
      var lmax = Number(R.laenge && R.laenge.max);
      if (p.wahl.kantung === FORMEL.kantung_aussen && p.masse.oberkante_breite !== undefined) lmax = Math.min(lmax, Math.floor((Number(FORMEL.laenge_max) - 2 * (p.masse.oberkante_breite - t)) / (Number(FORMEL.faktor) || 1)));
      setze('laenge', null, lmax);
      var bgr = Math.min(Number(R.breite && R.breite.max), p.masse.laenge);
      // Holzlager (05.10.2026): Breite und Hoehe nicht beide ueber paar_max
      if (FORMEL.paar_max !== undefined) bgr = p.masse.laenge > Number(FORMEL.paar_max) ? Math.min(Number(R.breite.max), Number(FORMEL.paar_max)) : Number(R.breite.max);
      // L-Form (04.10.2026): Breite hoechstens kuerzerer Schenkel minus schenkel_plus
      if (FORMEL.schenkel_plus !== undefined) {
        var lk3 = Math.min(p.masse.laenge, p.masse.laenge2);
        if (p.masse.laenge3 !== undefined) lk3 = Math.min(lk3, p.masse.laenge3);
        bgr = Math.min(bgr, lk3 - Number(FORMEL.schenkel_plus));
        // U-Form: Mitte mindestens 2 x Breite + mitte_plus
        if (FORMEL.mitte_plus !== undefined) bgr = Math.min(bgr, Math.floor((p.masse.laenge2 - Number(FORMEL.mitte_plus)) / 2));
      }
      if (R.breite) setze('breite', null, bgr);
      if (mn) {
        setze('oberkante_breite', mn[0], FORMEL.ok_max);
        setze('oberkante_hoehe', mn[1], Math.max(Number(mn[1]), Math.round(Number(p.masse.oberkante_breite) / 2)));
      }
      // 28.09.2026 (Martin): kleine Min-Max-Angabe unter jedem Maßfeld; folgt den aktuellen Grenzen
      // (Breite höchstens Länge, Länge bei Kante außen, Oberkante je Blechstärke).
      // 28.09.2026 (Martin): Maßfelder eines Schritts in einer Zeile (Länge/Breite/Höhe, Oberkante Breite/Höhe)
      var zeilen = root.querySelectorAll('.km-mass--mehr');
      for (var zi = 0; zi < zeilen.length; zi++) if (zeilen[zi].className.indexOf('km-mass--zeile') < 0) zeilen[zi].className += ' km-mass--zeile';
      var felder = root.querySelectorAll('input.km-f__mass');
      for (var gi = 0; gi < felder.length; gi++) {
        var fe = felder[gi], lab = fe.parentNode, gz = lab.querySelector('.km-mass__grenze');
        if (!gz) { gz = document.createElement('span'); gz.className = 'km-mass__grenze'; lab.appendChild(gz); }
        var gmin = fe.getAttribute('min'), gmax = fe.getAttribute('max'), gein = ' ' + ((R[fe.name] && R[fe.name].einheit) || 'mm');
        gz.textContent = gmin === gmax ? 'nur ' + gmin + gein : gmin + '–' + gmax + gein;
      }
    }
    // Mengenrabatt wie beim Lieferanten Gardomio (Hochbeet): kein eigener Rabattsatz - der Stueckpreis der Formel sinkt
    // ueber die Lieferkosten-Spalten 1/2/5 Stueck (Function: line.quantity). Anzeige wie dort: bei 1 Stueck
    // "−X % ab 2 Stueck" (X = gerundet (P1 − P2) / P1), sonst "−X % Mengenrabatt" gegenueber dem Einzelpreis;
    // dazu die Zeile "Stueckpreis bei 1 / 2 / ab 5 Stueck". Gibt den Rabatt in Prozent zurueck (0 ohne Formel).
    function mengenStaffel(s, p, stueck) {
      var badge = root.querySelector('[data-km-badge]'), zeileEl = root.querySelector('[data-km-staffel]');
      if (!FORMEL || !R.menge || !p) { if (badge) badge.hidden = true; return 0; }
      var p1 = kmAusstattungPreis(R, s, 1), p2 = kmAusstattungPreis(R, s, 2), p5 = kmAusstattungPreis(R, s, Number(FORMEL.menge_max) || 5);
      if (!p1 || !p2 || !p5) return 0;
      var g = function (x) { return Math.round(x * TAXF * 100) / 100; };
      var bezug = stueck > 1 ? p.total : p2.total;
      var proz = p1.total > 0 ? Math.round((p1.total - bezug) / p1.total * 100) : 0;
      if (badge) {
        badge.textContent = proz > 0 ? '−' + proz + ' % ' + (stueck > 1 ? 'Mengenrabatt' : 'ab 2 Stück') : '';
        badge.hidden = !(proz > 0);
      }
      if (zeileEl) zeileEl.textContent = 'Stückpreis bei 1 / 2 / ab ' + (Number(FORMEL.menge_max) || 5) + ' Stück: ' + fmt(g(p1.total)) + ' / ' + fmt(g(p2.total)) + ' / ' + fmt(g(p5.total));
      return stueck > 1 ? proz : 0;
    }
    // Parametrische Skizzen Hochbeet (27.09.2026): Schraegbild mit den Aussenmassen (Laenge, Breite, Hoehe in der Einheit
    // des Schritts), Kantung als Kante oben, Volumen nach Aussenmass; Querschnitt der Oberkante (Breite x Hoehe, Blech,
    // innen/aussen). Reine Anzeige - Grundlage sind die geklemmten Masse aus kmAusstattungPreis (p.masse, p.wahl).
    // Draufsicht L-Form (04.10.2026): Schenkel 1 waagerecht, Schenkel 2 senkrecht, Breite am Ende von Schenkel 1,
    // Kante als Rand (außen etwas breiter), Erde dunkel. Maße in der Einheit des Schritts. Reine Anzeige.
    function hbLform(p, e, zahl, ein, KA) {
      var L1 = Number(p.masse.laenge) || 1, L2 = Number(p.masse.laenge2) || 1, B = Number(p.masse.breite) || 1, H = Number(p.masse.hoehe) || 1;
      var sc = Math.min(270 / L1, 150 / L2), w = L1 * sc, h = L2 * sc, b = Math.max(6, B * sc);
      var x0 = Math.round((330 - w) / 2 + 30), y0 = 186, aussen = p.wahl.kantung === KA; // rechts ~100 px fuer die Breite
      var rim = Math.max(2, Math.min(b / 3, aussen ? 5 : 3.5));
      var pt = function (a) { return a.map(function (q) { return q[0].toFixed(1) + ',' + q[1].toFixed(1); }).join(' '); };
      var poly = function (r) { return pt([[x0 + r, y0 - r], [x0 + w - r, y0 - r], [x0 + w - r, y0 - b + r], [x0 + b - r, y0 - b + r], [x0 + b - r, y0 - h + r], [x0 + r, y0 - h + r]]); };
      var g = '<polygon points="' + poly(0) + '" fill="#b5652b"/><polygon points="' + poly(rim) + '" fill="#4a2e1c"/>';
      var yl = y0 + 14;
      g += '<path class="km-hb__linie" d="M' + x0 + ' ' + (yl - 4) + 'v8M' + (x0 + w).toFixed(1) + ' ' + (yl - 4) + 'v8M' + x0 + ' ' + yl + 'H' + (x0 + w).toFixed(1) + '"/>';
      g += '<text class="km-hb__mass" x="' + (x0 + w / 2).toFixed(1) + '" y="' + (yl + 15) + '" text-anchor="middle">Schenkel 1 · ' + zahl(L1) + ' ' + ein + '</text>';
      var xs = x0 - 12, ym = y0 - h / 2;
      g += '<path class="km-hb__linie" d="M' + (xs - 4) + ' ' + (y0 - h).toFixed(1) + 'h8M' + (xs - 4) + ' ' + y0 + 'h8M' + xs + ' ' + (y0 - h).toFixed(1) + 'V' + y0 + '"/>';
      // kurzer Schenkel 2 (unter 100 px): Beschriftung waagerecht über dem Schenkel statt gedreht daneben
      if (h >= 100) g += '<text class="km-hb__mass" x="' + (xs - 6) + '" y="' + ym.toFixed(1) + '" text-anchor="middle" transform="rotate(-90 ' + (xs - 6) + ' ' + ym.toFixed(1) + ')">Schenkel 2 · ' + zahl(L2) + ' ' + ein + '</text>';
      else g += '<text class="km-hb__mass" x="' + (xs - 6) + '" y="' + (y0 - h - 8).toFixed(1) + '">Schenkel 2 · ' + zahl(L2) + ' ' + ein + '</text>';
      var xb = x0 + w + 10;
      g += '<path class="km-hb__linie" d="M' + (xb - 4) + ' ' + (y0 - b).toFixed(1) + 'h8M' + (xb - 4) + ' ' + y0 + 'h8M' + xb + ' ' + (y0 - b).toFixed(1) + 'V' + y0 + '"/>';
      g += '<text class="km-hb__mass" x="' + (xb + 6).toFixed(1) + '" y="' + (y0 - b / 2 + 4).toFixed(1) + '">Breite ' + zahl(B) + ' ' + ein + '</text>';
      g += '<text x="10" y="18">Draufsicht · Höhe ' + zahl(H) + ' ' + ein + ' · Blech ' + e(p.wahl.blech) + ' mm · Kante ' + (aussen ? 'nach außen' : 'nach innen') + '</text>';
      return g;
    }
    // Draufsicht U-Form (05.10.2026): Mitte waagerecht unten, Schenkel links und rechts senkrecht, Breite am rechten Schenkel.
    function hbUform(p, e, zahl, ein, KA) {
      var L1 = Number(p.masse.laenge) || 1, L2 = Number(p.masse.laenge2) || 1, L3 = Number(p.masse.laenge3) || 1, B = Number(p.masse.breite) || 1, H = Number(p.masse.hoehe) || 1;
      var sc = Math.min(270 / L2, 150 / Math.max(L1, L3)), w = L2 * sc, h1 = L1 * sc, h3 = L3 * sc, b = Math.max(6, B * sc);
      var x0 = Math.round((330 - w) / 2 + 30), y0 = 186, aussen = p.wahl.kantung === KA;
      var rim = Math.max(2, Math.min(b / 3, aussen ? 5 : 3.5));
      var pt = function (a) { return a.map(function (q) { return q[0].toFixed(1) + ',' + q[1].toFixed(1); }).join(' '); };
      var poly = function (r) { return pt([[x0 + r, y0 - r], [x0 + w - r, y0 - r], [x0 + w - r, y0 - h3 + r], [x0 + w - b + r, y0 - h3 + r], [x0 + w - b + r, y0 - b + r], [x0 + b - r, y0 - b + r], [x0 + b - r, y0 - h1 + r], [x0 + r, y0 - h1 + r]]); };
      var g = '<polygon points="' + poly(0) + '" fill="#b5652b"/><polygon points="' + poly(rim) + '" fill="#4a2e1c"/>';
      var yl = y0 + 14;
      g += '<path class="km-hb__linie" d="M' + x0 + ' ' + (yl - 4) + 'v8M' + (x0 + w).toFixed(1) + ' ' + (yl - 4) + 'v8M' + x0 + ' ' + yl + 'H' + (x0 + w).toFixed(1) + '"/>';
      g += '<text class="km-hb__mass" x="' + (x0 + w / 2).toFixed(1) + '" y="' + (yl + 15) + '" text-anchor="middle">Mitte · ' + zahl(L2) + ' ' + ein + '</text>';
      var xs = x0 - 12, ym = y0 - h1 / 2;
      g += '<path class="km-hb__linie" d="M' + (xs - 4) + ' ' + (y0 - h1).toFixed(1) + 'h8M' + (xs - 4) + ' ' + y0 + 'h8M' + xs + ' ' + (y0 - h1).toFixed(1) + 'V' + y0 + '"/>';
      var tl = 'Links · ' + zahl(L1) + ' ' + ein;
      // gedreht neben dem Schenkel, solange der Text daneben Platz hat (ca. 6,2 px je Zeichen), sonst waagerecht darueber
      if (h1 >= tl.length * 6.2) g += '<text class="km-hb__mass" x="' + (xs - 6) + '" y="' + ym.toFixed(1) + '" text-anchor="middle" transform="rotate(-90 ' + (xs - 6) + ' ' + ym.toFixed(1) + ')">' + tl + '</text>';
      else g += '<text class="km-hb__mass" x="' + x0 + '" y="' + (y0 - h1 - 8).toFixed(1) + '">' + tl + '</text>';
      var xr = x0 + w + 10, yr = y0 - h3 / 2;
      g += '<path class="km-hb__linie" d="M' + (xr - 4) + ' ' + (y0 - h3).toFixed(1) + 'h8M' + (xr - 4) + ' ' + y0 + 'h8M' + xr + ' ' + (y0 - h3).toFixed(1) + 'V' + y0 + '"/>';
      g += '<text class="km-hb__mass" x="' + (xr + 6) + '" y="' + (yr + 4).toFixed(1) + '">Rechts · ' + zahl(L3) + ' ' + ein + '</text>';
      // Breite steht in der Kopfzeile: bei schmalen U (kurze Mitte) haette eine Beschriftung am Schenkel keinen Platz
      g += '<text x="10" y="18">Breite ' + zahl(B) + ' ' + ein + ' · Höhe ' + zahl(H) + ' ' + ein + ' · Blech ' + e(p.wahl.blech) + ' mm · Kante ' + (aussen ? 'nach außen' : 'nach innen') + '</text>';
      return g;
    }
    // Holzlager (05.10.2026): Schraegbild von vorn - Rahmen Breite x Hoehe, Tiefe nach hinten, Kante als Rand der
    // Oeffnung, Rueckwand dunkel. Masse: laenge = Breite, breite = Hoehe, hoehe = Tiefe (Gardomio-Formel). Reine Anzeige.
    function hlSkizze(p, e, zahl, ein) {
      var B = Number(p.masse.laenge) || 1, Hh = Number(p.masse.breite) || 1, T = Number(p.masse.hoehe) || 1;
      var sc = Math.min(290 / (B + 0.433 * T), 150 / (Hh + 0.25 * T)), w = B * sc, h = Hh * sc, dx = 0.433 * T * sc, dy = 0.25 * T * sc;
      var x0 = Math.round((360 - (w + dx)) / 2 + 30), y0 = 190, yt = y0 - h, rueck = FORMEL.boden && p.wahl.boden === FORMEL.boden[0];
      var k = Math.max(3, Math.min(Math.min(w, h) / 4, (Number(p.masse.kantung_mass) || 50) / 10 * sc));
      var pt = function (a) { return a.map(function (q) { return q[0].toFixed(1) + ',' + q[1].toFixed(1); }).join(' '); };
      var g = '<polygon points="' + pt([[x0 + w, y0], [x0 + w + dx, y0 - dy], [x0 + w + dx, yt - dy], [x0 + w, yt]]) + '" fill="#8f4a1d"/>';
      g += '<polygon points="' + pt([[x0, yt], [x0 + w, yt], [x0 + w + dx, yt - dy], [x0 + dx, yt - dy]]) + '" fill="#c98548"/>';
      g += '<rect x="' + x0 + '" y="' + yt.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" fill="#b5652b"/>';
      g += '<rect x="' + (x0 + k).toFixed(1) + '" y="' + (yt + k).toFixed(1) + '" width="' + Math.max(1, w - 2 * k).toFixed(1) + '" height="' + Math.max(1, h - 2 * k).toFixed(1) + '" fill="' + (rueck ? '#5a321a' : '#efe7dd') + '"/>';
      var yl = y0 + 16;
      g += '<path class="km-hb__linie" d="M' + x0 + ' ' + (yl - 4) + 'v8M' + (x0 + w).toFixed(1) + ' ' + (yl - 4) + 'v8M' + x0 + ' ' + yl + 'H' + (x0 + w).toFixed(1) + '"/>';
      g += '<text class="km-hb__mass" x="' + (x0 + w / 2).toFixed(1) + '" y="' + (yl + 15) + '" text-anchor="middle">Breite ' + zahl(B) + ' ' + ein + '</text>';
      var xh = x0 - 14, ym = ((yt + y0) / 2).toFixed(1);
      g += '<path class="km-hb__linie" d="M' + (xh - 4) + ' ' + yt.toFixed(1) + 'h8M' + (xh - 4) + ' ' + y0 + 'h8M' + xh + ' ' + yt.toFixed(1) + 'V' + y0 + '"/>';
      g += '<text class="km-hb__mass" x="' + (xh - 8) + '" y="' + ym + '" text-anchor="middle" transform="rotate(-90 ' + (xh - 8) + ' ' + ym + ')">Höhe ' + zahl(Hh) + ' ' + ein + '</text>';
      var bx = x0 + w + 8, by = y0 + 4;
      g += '<path class="km-hb__linie" d="M' + bx.toFixed(1) + ' ' + by + 'L' + (bx + dx).toFixed(1) + ' ' + (by - dy).toFixed(1) + '"/>';
      g += '<text class="km-hb__mass" x="' + Math.min(bx + dx / 2 + 8, 338).toFixed(1) + '" y="' + (by - dy / 2 + 14).toFixed(1) + '">Tiefe ' + zahl(T) + ' ' + ein + '</text>';
      g += '<text x="10" y="18">Blech ' + e(p.wahl.blech) + ' mm · ' + (rueck ? 'mit' : 'ohne') + ' Rückwand · Kante ' + zahl(Number(p.masse.kantung_mass) || 50) + ' mm</text>';
      return g;
    }
    // Fahrradueberdachung Tia (10.10.2026, formel.art "modul"): Vorderansicht (Dachbreite, Stuetzenachsen, lichte Hoehe und
    // Gesamthoehe, Fundament -200/-800, Rueckwand und Seitenwaende) und Seitenansicht (Dachtiefe, Stuetzenachse, Doppelstuetze
    // bei doppelseitig) nach der Gronard-Zeichnung 06/2026. Reine Anzeige aus p.ctx.modul und p.wahl - Grundlage ist die
    // geklemmte Konfiguration der Preislogik. Zeichnet in jede Box [data-km-tia-skizze] (Modul- und Breitenschritt).
    function tiaSkizze(p) {
      var mk = p.ctx && p.ctx.modul; if (!mk) return '';
      var zahl = function (n) { return Number(n).toLocaleString('de-DE'); };
      var doppel = p.wahl.version === 'doppelseitig', hoch = p.wahl.hoehe === '2820';
      var B = mk.dachbreite, n = mk.n, H = hoch ? 2980 : 2380, L = hoch ? 2820 : 2220, DACH = H - L;
      var T = doppel ? 4400 : 2250, ACHSE = doppel ? 3220 : 1490;
      var FUND_OK = 200, FUND_UK = 800, FUND_B = 500, UEB = 45; // Ueberstand Dach ueber die aeusseren Stuetzenachsen
      var rueck = !doppel && p.wahl.rueckwand && p.wahl.rueckwand !== 'ohne';
      var sw = p.wahl.seitenwaende || 'ohne', links = sw === 'links' || sw === 'beide', rechts = sw === 'rechts' || sw === 'beide';
      var pt = function (x) { return Number(x).toFixed(1); };
      var g = '<text x="10" y="16">' + (doppel ? 'Doppelseitig' : 'Einseitig') + ' · ' + n + (n > 1 ? ' Module' : ' Modul') + ' · Höhe ' + zahl(H) + ' mm, lichte Höhe ' + zahl(L) + ' mm</text>';
      // --- Vorderansicht: Breite bis 262 px, Hoehe bis 112 px (Dachoberkante bis Fundamentsohle), Boden bei y = 158
      var sc = Math.min(262 / B, 112 / (H + FUND_UK)), x0 = 44, yB = 158;
      var w = B * sc, yD = yB - H * sc, hD = Math.max(3, DACH * sc);
      var innen = B - 2 * UEB, achsen = [];
      for (var i = 0; i <= n; i++) achsen.push(x0 + (UEB + innen * i / n) * sc);
      var fb = Math.max(4, FUND_B * sc), fo = yB + FUND_OK * sc, fu = yB + FUND_UK * sc, stw = Math.max(1.5, 100 * sc);
      for (var a = 0; a < achsen.length; a++) {
        g += '<rect x="' + pt(achsen[a] - fb / 2) + '" y="' + pt(fo) + '" width="' + pt(fb) + '" height="' + pt(fu - fo) + '" fill="#e5e7eb" stroke="#9ca3af" stroke-width="0.8"/>';
        g += '<line x1="' + pt(achsen[a]) + '" y1="' + pt(yD + hD) + '" x2="' + pt(achsen[a]) + '" y2="' + pt(fo) + '" stroke="#1f2937" stroke-width="' + pt(stw) + '"/>';
      }
      if (rueck) g += '<rect x="' + pt(achsen[0]) + '" y="' + pt(yD + hD) + '" width="' + pt(achsen[n] - achsen[0]) + '" height="' + pt(yB - yD - hD) + '" fill="#cbd5e1" opacity="0.7"/>';
      var swb = Math.max(3, 60 * sc);
      if (links) g += '<rect x="' + pt(achsen[0] - swb / 2) + '" y="' + pt(yD + hD) + '" width="' + pt(swb) + '" height="' + pt(yB - yD - hD) + '" fill="#64748b"/>';
      if (rechts) g += '<rect x="' + pt(achsen[n] - swb / 2) + '" y="' + pt(yD + hD) + '" width="' + pt(swb) + '" height="' + pt(yB - yD - hD) + '" fill="#64748b"/>';
      g += '<rect x="' + x0 + '" y="' + pt(yD) + '" width="' + pt(w) + '" height="' + pt(hD) + '" fill="#374151"/>';
      g += '<line x1="' + (x0 - 8) + '" y1="' + yB + '" x2="' + pt(x0 + w + 8) + '" y2="' + yB + '" stroke="#9ca3af" stroke-width="0.8" stroke-dasharray="3 2"/>';
      g += '<text x="' + pt(x0 + w + 10) + '" y="' + pt(yB + 4) + '" font-size="10">±0</text>';
      // Dachbreite oben
      var yo = yD - 10;
      g += '<path class="km-hb__linie" d="M' + x0 + ' ' + pt(yo - 4) + 'v8M' + pt(x0 + w) + ' ' + pt(yo - 4) + 'v8M' + x0 + ' ' + yo + 'H' + pt(x0 + w) + '"/>';
      g += '<text class="km-hb__mass" x="' + pt(x0 + w / 2) + '" y="' + pt(yo - 5) + '" text-anchor="middle">Dachbreite ' + zahl(B) + ' mm</text>';
      // Gesamthoehe links (gedreht)
      var xl = x0 - 14, ym = (yD + yB) / 2;
      g += '<path class="km-hb__linie" d="M' + pt(xl - 4) + ' ' + pt(yD) + 'h8M' + pt(xl - 4) + ' ' + yB + 'h8M' + xl + ' ' + pt(yD) + 'V' + yB + '"/>';
      g += '<text class="km-hb__mass" x="' + pt(xl - 6) + '" y="' + pt(ym) + '" text-anchor="middle" transform="rotate(-90 ' + pt(xl - 6) + ' ' + pt(ym) + ')">' + zahl(H) + ' mm</text>';
      // Stuetzenachsen unten, Fundamentangabe darunter
      var yu = fu + 10, achs = Math.round(innen / n);
      g += '<path class="km-hb__linie" d="M' + pt(achsen[0]) + ' ' + pt(yu - 4) + 'v8M' + pt(achsen[n]) + ' ' + pt(yu - 4) + 'v8M' + pt(achsen[0]) + ' ' + yu + 'H' + pt(achsen[n]) + '"/>';
      for (var m = 1; m < n; m++) g += '<path class="km-hb__linie" d="M' + pt(achsen[m]) + ' ' + pt(yu - 4) + 'v8"/>';
      g += '<text class="km-hb__mass" x="' + pt((achsen[0] + achsen[n]) / 2) + '" y="' + pt(yu + 13) + '" text-anchor="middle">' + (n > 1 ? n + ' × ' : '') + 'Stützenachse ' + zahl(achs) + ' mm</text>';
      g += '<text x="' + x0 + '" y="' + pt(yu + 28) + '" font-size="10">Fundamente bauseits ' + FUND_B + ' × ' + FUND_B + ' mm, OK −' + FUND_OK + ' / UK −' + FUND_UK + ' mm</text>';
      // --- Seitenansicht rechts, Boden auf gleicher Hoehe: Dachtiefe, Stuetzenachse, Doppelstuetze
      var ss = Math.min(86 / T, sc), sx0 = 342, sT = T * ss, syD = yB - H * ss, shD = Math.max(2, DACH * ss);
      var ueb = (T - ACHSE) / 2, ax1 = sx0 + ueb * ss, ax2 = sx0 + (T - ueb) * ss, sstw = Math.max(1.2, 100 * ss);
      g += '<text x="430" y="34" text-anchor="end" font-size="11">Seitenansicht</text>';
      var posten = [ax1, ax2]; if (doppel) { posten.push(sx0 + (T / 2 - 97.5) * ss, sx0 + (T / 2 + 97.5) * ss); }
      for (var q = 0; q < posten.length; q++) {
        g += '<rect x="' + pt(posten[q] - Math.max(2, FUND_B * ss) / 2) + '" y="' + pt(yB + FUND_OK * ss) + '" width="' + pt(Math.max(2, FUND_B * ss)) + '" height="' + pt((FUND_UK - FUND_OK) * ss) + '" fill="#e5e7eb" stroke="#9ca3af" stroke-width="0.6"/>';
        g += '<line x1="' + pt(posten[q]) + '" y1="' + pt(syD + shD) + '" x2="' + pt(posten[q]) + '" y2="' + pt(yB + FUND_OK * ss) + '" stroke="#1f2937" stroke-width="' + pt(sstw) + '"/>';
      }
      if (rueck) g += '<line x1="' + pt(ax2) + '" y1="' + pt(syD + shD) + '" x2="' + pt(ax2) + '" y2="' + pt(yB) + '" stroke="#64748b" stroke-width="' + pt(sstw * 2.5) + '" opacity="0.7"/>';
      if (links || rechts) g += '<rect x="' + pt(ax1) + '" y="' + pt(syD + shD) + '" width="' + pt(ax2 - ax1) + '" height="' + pt(yB - syD - shD) + '" fill="#64748b" opacity="0.35"/>';
      g += '<rect x="' + pt(sx0) + '" y="' + pt(syD) + '" width="' + pt(sT) + '" height="' + pt(shD) + '" fill="#374151"/>';
      g += '<line x1="' + pt(sx0 - 4) + '" y1="' + yB + '" x2="' + pt(sx0 + sT + 4) + '" y2="' + yB + '" stroke="#9ca3af" stroke-width="0.8" stroke-dasharray="3 2"/>';
      var syo = syD - 8;
      g += '<path class="km-hb__linie" d="M' + pt(sx0) + ' ' + pt(syo - 3) + 'v6M' + pt(sx0 + sT) + ' ' + pt(syo - 3) + 'v6M' + pt(sx0) + ' ' + syo + 'H' + pt(sx0 + sT) + '"/>';
      g += '<text class="km-hb__mass" x="' + pt(sx0 + sT / 2) + '" y="' + pt(syo - 4) + '" text-anchor="middle" font-size="11">Tiefe ' + zahl(T) + '</text>';
      g += '<path class="km-hb__linie" d="M' + pt(ax1) + ' ' + pt(yu - 3) + 'v6M' + pt(ax2) + ' ' + pt(yu - 3) + 'v6M' + pt(ax1) + ' ' + yu + 'H' + pt(ax2) + '"/>';
      g += '<text class="km-hb__mass" x="' + pt((ax1 + ax2) / 2) + '" y="' + pt(yu + 13) + '" text-anchor="middle" font-size="11">' + zahl(ACHSE) + '</text>';
      if (doppel) g += '<text x="' + pt(sx0 + sT / 2) + '" y="' + pt(yu + 28) + '" text-anchor="middle" font-size="10">Doppelstütze</text>';
      return g;
    }
    // Die Zeichnungsboxen legt das Skript selbst an (in jedem Schritt mit def.skizze "tia", vor den Karten bzw. dem
    // Massfeld) - das Snippet km-vordach-form.liquid bleibt dafuer unveraendert.
    function tiaSkizzen(p) {
      var boxen = root.querySelectorAll('[data-km-tia-skizze]');
      if (!boxen.length) {
        SCHRITTE.forEach(function (st) {
          var d = R[st]; if (!d || d.skizze !== 'tia') return;
          var sec = root.querySelector('.km-step[data-step="' + st + '"] .km-f'); if (!sec) return;
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('class', 'km-skz km-skz--hb'); svg.setAttribute('viewBox', '0 0 440 250'); svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', 'Zeichnung Ihrer Fahrradüberdachung: Vorderansicht mit Dachbreite, Stützenachsen und Höhen, Seitenansicht mit Dachtiefe und Stützenachse');
          svg.setAttribute('data-km-tia-skizze', '');
          var vor = sec.querySelector('.km-cards, .km-mass');
          if (vor) sec.insertBefore(svg, vor); else sec.appendChild(svg);
        });
        boxen = root.querySelectorAll('[data-km-tia-skizze]');
      }
      var g = tiaSkizze(p);
      for (var i = 0; i < boxen.length; i++) boxen[i].innerHTML = g;
      // Galerie-Kachel und Thumbnail (tiaGalerie) liegen ausserhalb des Konfigurators
      var gal = document.querySelectorAll('.km-tia-cell [data-km-tia-skizze], .km-tia-thumb [data-km-tia-skizze]');
      for (var j = 0; j < gal.length; j++) gal[j].innerHTML = g;
      if (tiaGal) tia3dUpdate(p);
    }
    // Live-Ansichten in der Produktgalerie (Martin 10.10.2026, nach dem Go-Live): zwei eigene Kacheln vor den Fotos -
    // die 3D-Ansicht (km-tia-3d.js, eigenes three.js-Modell, nachgeladen) und die Masszeichnung (dieselbe SVG wie in den
    // Schritten), je mit Thumbnail. tiaSkizzen zeichnet beide bei jeder Eingabe neu. Beim Laden bleibt das Produktfoto
    // stehen (wie beim Vordach-Rendering); mit der ersten Eingabe springt die Galerie auf die 3D-Ansicht, danach
    // entscheidet der Besucher ueber die Thumbnails. Der Zoom-Knopf (PhotoSwipe kennt die Kacheln nicht) wird dort
    // ausgeblendet. Ohne Flickity (Theme-Wechsel) stehen die Kacheln einfach vor dem ersten Bild.
    var TIA3D_VERSION = '2026101003';
    var tiaGal = null, tiaGalGezeigt = false, tia3d = { viewer: null, laedt: false, cfg: null, timer: null, box: null };
    function tiaZelle(klasse, mediaId, pos, typ, html) {
      var cell = document.createElement('div');
      cell.className = 'product__media-item ' + klasse;
      cell.id = klasse + '-' + sid;
      cell.setAttribute('data-media-type', typ); cell.setAttribute('data-media-id', mediaId);
      cell.setAttribute('data-original-position', pos);
      cell.innerHTML = html;
      return cell;
    }
    function tiaThumb(klasse, mediaId, label, html) {
      var t = document.createElement('button');
      t.type = 'button'; t.tabIndex = -1; t.className = 'product__thumbnail-item ' + klasse;
      t.setAttribute('data-media-id', mediaId); t.setAttribute('aria-label', label);
      t.innerHTML = '<div class="product__thumbnail km-tia-thumb__box">' + html + '</div>';
      return t;
    }
    var TIA_ICON = {
      cube: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Z"/><path d="M4 7.5 12 12l8-4.5M12 12v9"/></svg>',
      vorne: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="4" y="6" width="16" height="12" rx="1"/><path d="M4 10h16"/></svg>',
      seite: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="7" y="5" width="10" height="14" rx="1"/><path d="M7 9h10"/></svg>',
      oben: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="1"/><path d="M4 12h16M12 4v16"/></svg>',
      reset: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v4.5h-4.5"/></svg>'
    };
    function tiaGalerie() {
      if (!MODUL || tiaGal) return;
      var car = document.querySelector('flickity-carousel.product__media-list, .product__media-list');
      var erstes = car && car.querySelector('.product__media-item');
      if (!car || !erstes) return;
      var labelZ = 'Zeichnung Ihrer Fahrradüberdachung: Vorderansicht mit Dachbreite, Stützenachsen und Höhen, Seitenansicht mit Dachtiefe und Stützenachse';
      var knoepfe = [['perspektive', 'Perspektive', TIA_ICON.cube], ['vorne', 'Vorderansicht', TIA_ICON.vorne], ['seite', 'Seitenansicht', TIA_ICON.seite], ['oben', 'Draufsicht', TIA_ICON.oben], ['reset', 'Zurücksetzen', TIA_ICON.reset]]
        .map(function (k) { return '<button type="button" class="km-tia-3d__knopf" data-km-3d-view="' + k[0] + '">' + k[2] + '<span>' + k[1] + '</span></button>'; }).join('');
      var cell3d = tiaZelle('km-tia-3d-cell', 'km-tia-3d', '-2', 'drawing',
        '<div class="product__media-image-wrapper aspect-ratio aspect-ratio--natural km-tia-cell__wrap" style="padding-bottom: 62.5%; --aspect-ratio: 1.6">'
        + '<div class="km-tia-3d__box" data-km-tia-3d role="img" aria-label="3D-Ansicht Ihrer Fahrradüberdachung, mit Maus oder Finger drehbar"></div>'
        + '<div class="km-tia-3d__bar" role="group" aria-label="Ansicht wählen">' + knoepfe + '</div>'
        + '<p class="km-tia-3d__hinweis" data-km-3d-hinweis>3D-Ansicht wird geladen …</p></div>');
      var cellZ = tiaZelle('km-tia-cell', 'km-tia', '-1', 'drawing',
        '<div class="product__media-image-wrapper aspect-ratio aspect-ratio--natural km-tia-cell__wrap" style="padding-bottom: 56.82%; --aspect-ratio: 1.76">'
        + '<svg class="km-skz--hb km-tia-cell__svg" viewBox="0 0 440 250" role="img" aria-label="' + labelZ + '" data-km-tia-skizze></svg></div>');
      var thumb3d = null, thumbZ = null, liste = document.querySelector('.product__thumbnail-list-inner');
      if (liste) {
        thumbZ = tiaThumb('km-tia-thumb', 'km-tia', 'Maßzeichnung Ihrer Konfiguration anzeigen', '<svg class="km-skz--hb" viewBox="0 0 440 250" aria-hidden="true" data-km-tia-skizze></svg>');
        thumb3d = tiaThumb('km-tia-thumb km-tia-thumb--3d', 'km-tia-3d', '3D-Ansicht Ihrer Konfiguration anzeigen', '<span class="km-tia-thumb__3d">' + TIA_ICON.cube + '<small>3D</small></span>');
        liste.insertBefore(thumbZ, liste.firstChild);
        liste.insertBefore(thumb3d, liste.firstChild);
      }
      tiaGal = { car: car, zellen: [cell3d, cellZ], thumbs: [thumb3d, thumbZ], erstes: erstes, zoom: document.querySelector('.product__zoom-button'), gebunden: false };
      // Flickity baut das Theme erst auf, wenn die Galerie sichtbar ist (untilVisible, z. B. Tab im Hintergrund):
      // die Kacheln kommen deshalb sofort vor das erste Bild in den DOM - beim Aufbau nimmt Flickity sie als erste
      // Zellen mit (initialIndex .is-initial-selected haelt das Foto). Laeuft Flickity schon, kennt es die Kacheln
      // nicht (getCell null) und bekommt sie per prepend. data-original-position -2/-1 haelt sie bei reload() vorn.
      // Laeuft Flickity schon, liegt das erste Bild im .flickity-slider - deshalb ueber den tatsaechlichen Elternknoten
      // einfuegen (insertBefore am Carousel-Element wirft sonst, V104-Fehler 10.10.2026).
      var eltern = erstes.parentNode || car;
      eltern.insertBefore(cell3d, erstes); eltern.insertBefore(cellZ, erstes);
      tiaFlickity(function (f) {
        if (!f || typeof f.getCell !== 'function' || typeof f.prepend !== 'function') return;
        if (!f.getCell(cellZ)) f.prepend(cellZ);
        if (!f.getCell(cell3d)) f.prepend(cell3d);
      });
      if (thumb3d) thumb3d.addEventListener('click', function () { tiaGalerieZeigen(cell3d, true); });
      if (thumbZ) thumbZ.addEventListener('click', function () { tiaGalerieZeigen(cellZ, true); });
      // Drehen im 3D-Fenster darf den Slider nicht mitziehen und die Klick-Navigation (click-nav) nicht ausloesen
      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (ev) {
        cell3d.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: ev !== 'click' });
      });
      cell3d.addEventListener('click', function (e) {
        var b = e.target.closest('[data-km-3d-view]'); if (!b || !tia3d.viewer) return;
        var v = b.getAttribute('data-km-3d-view');
        if (v === 'reset') tia3d.viewer.reset(); else tia3d.viewer.view(v);
      });
      tia3d.box = cell3d.querySelector('[data-km-tia-3d]');
      var p = kmAusstattungPreis(R, state(), menge());
      if (p) tiaSkizzen(p);
      tia3dLaden();
    }
    // Flickity-Instanz holen (sofort oder per Promise) und beim ersten Treffer Auswahl-Markierung und Zoom binden
    function tiaFlickity(cb) {
      var car = tiaGal.car, inst = car.flickityInstance || (window.Flickity && window.Flickity.data(car));
      var fertig = function (f) {
        if (f && !tiaGal.gebunden && typeof f.on === 'function') {
          tiaGal.gebunden = true;
          f.on('select', function () { tiaMarkieren(f); });
          tiaMarkieren(f);
        }
        cb(f || null);
      };
      if (!inst) { cb(null); return; }
      if (typeof inst.then === 'function') inst.then(fertig).catch(function () { cb(null); }); else fertig(inst);
    }
    function tiaMarkieren(f) {
      var sel = f.selectedElement, idx = tiaGal.zellen.indexOf(sel), zoom = tiaGal.zoom;
      if (zoom) zoom.hidden = idx >= 0 || !!(sel && sel.getAttribute('data-media-type') !== 'image');
      for (var i = 0; i < tiaGal.thumbs.length; i++) {
        var t = tiaGal.thumbs[i]; if (!t) continue;
        if (i === idx) {
          // Das Theme markiert die Thumbnails nach seiner beim Laden gezaehlten Liste (ohne unsere) - daher selbst setzen
          var alle = t.parentNode ? t.parentNode.querySelectorAll('.product__thumbnail-item[aria-current]') : [];
          for (var a = 0; a < alle.length; a++) if (alle[a] !== t) alle[a].removeAttribute('aria-current');
          t.setAttribute('aria-current', 'true');
        } else t.removeAttribute('aria-current');
      }
      if (idx === 0 && tia3d.viewer) tia3d.viewer.resize();
    }
    function tiaGalerieZeigen(cell, erzwingen) {
      if (!tiaGal) return;
      if (!erzwingen && tiaGalGezeigt) return;
      tiaGalGezeigt = true;
      tiaFlickity(function (f) {
        if (f && typeof f.selectCell === 'function') f.selectCell(cell, false, true);
        else cell.scrollIntoView({ block: 'nearest' });
      });
    }
    // 3D-Viewer nachladen (Theme-Asset km-tia-3d.js, Pfad aus dem eigenen Skript-Tag) - erst wenn der Browser Luft hat
    function tia3dLaden() {
      if (tia3d.laedt || tia3d.viewer) return;
      tia3d.laedt = true;
      var eigenes = document.querySelector('script[src*="km-ausstattung"]');
      if (!eigenes) { tia3dFehler(); return; }
      // ?v= ist der einzige Parameter, den die Shopify-CDN als Cache-Schluessel nimmt (max-age 1 Jahr) - bei jeder
      // neuen km-tia-3d.js die Nummer hochsetzen.
      var src = eigenes.getAttribute('src').replace(/km-ausstattung(\.min)?\.js(\?[^#]*)?/, 'km-tia-3d.js?v=' + TIA3D_VERSION);
      var start = function () {
        if (window.KMTia3D) { tia3dMounten(); return; }
        var sc = document.createElement('script');
        sc.src = src; sc.async = true;
        sc.onload = tia3dMounten; sc.onerror = tia3dFehler;
        document.head.appendChild(sc);
      };
      if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 2500 }); else setTimeout(start, 1200);
    }
    function tia3dFehler() {
      var h = tiaGal && tiaGal.zellen[0].querySelector('[data-km-3d-hinweis]');
      if (h) h.textContent = 'Die 3D-Ansicht steht in diesem Browser nicht zur Verfügung – die Maßzeichnung finden Sie in der nächsten Kachel.';
    }
    function tia3dMounten() {
      if (tia3d.viewer || !window.KMTia3D || !tia3d.box) return;
      try {
        tia3d.viewer = window.KMTia3D.mount(tia3d.box);
      } catch (e) { tia3dFehler(); return; }
      var h = tiaGal.zellen[0].querySelector('[data-km-3d-hinweis]'); if (h) h.remove();
      if (tia3d.cfg) tia3d.viewer.update(tia3d.cfg);
    }
    // Konfiguration fuer das 3D-Modell aus der aufgeloesten Wahl (p.wahl, p.sicht) und dem Modulkontext
    function tiaKonfig3D(p) {
      var mk = p.ctx && p.ctx.modul; if (!mk) return null;
      var w = p.wahl, doppel = w.version === 'doppelseitig', hoch = w.hoehe === '2820';
      var sw = w.seitenwaende || 'ohne', ent = String(w.entwaesserung || 'ohne');
      return {
        B: mk.dachbreite, n: mk.n, doppel: doppel, H: hoch ? 2980 : 2380, L: hoch ? 2820 : 2220, T: doppel ? 4400 : 2250, achse: doppel ? 3220 : 1490,
        rueckwand: (!doppel && p.sicht.rueckwand) ? (w.rueckwand || 'ohne') : 'ohne',
        seitenLinks: sw === 'links' || sw === 'beide', seitenRechts: sw === 'rechts' || sw === 'beide', seitenMat: w.seitenwand_material || '7016',
        konstruktion: w.konstruktion || 'verzinkt', attika: w.attika || '7016',
        led: w.beleuchtung === 'led', rinne: ent !== 'ohne', rinneFarbe: /schwarz/.test(ent) ? 'schwarz' : 'grau', rinneUnter: /^unter/.test(ent),
        fallrohr: p.sicht.fallrohr ? (w.fallrohr || 'links') : 'links', begruenung: w.dachbegruenung === 'vorgerichtet'
      };
    }
    function tia3dUpdate(p) {
      var cfg = tiaKonfig3D(p); if (!cfg) return;
      tia3d.cfg = cfg;
      if (!tia3d.viewer) return;
      if (tia3d.timer) clearTimeout(tia3d.timer);
      tia3d.timer = setTimeout(function () { tia3d.timer = null; tia3d.viewer.update(tia3d.cfg); }, 120);
    }
    function hbSkizzen(p) {
      if (!FORMEL || !p) return;
      if (MODUL) { tiaSkizzen(p); return; }
      var e = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;'); };
      var zahl = function (n) { return Number(n).toLocaleString('de-DE'); };
      var ein = (R.laenge && R.laenge.einheit) || 'mm';
      var box = root.querySelector('[data-km-hb-skizze]');
      // Kante aussen: Options-ID aus der Formel, sonst "aussen" (04.10.2026: Bausatz und L-Form haben kein kantung_aussen
      // in der Formel - die Skizzen zeigten dort immer "nach innen")
      var KA = FORMEL.kantung_aussen || 'aussen';
      if (box && FORMEL.form === 'holzlager') { box.innerHTML = hlSkizze(p, e, zahl, ein); box.setAttribute('aria-label', 'Maßskizze Ihres Holzlagers mit Breite, Höhe und Tiefe'); }
      else if (box && FORMEL.art === 'hochbeet_lform') box.innerHTML = p.masse.laenge3 !== undefined ? hbUform(p, e, zahl, ein, KA) : hbLform(p, e, zahl, ein, KA);
      else if (box) {
        var L = Number(p.masse.laenge) || 1, B = Number(p.masse.breite) || 1, H = Number(p.masse.hoehe) || 1;
        var sc = Math.min(290 / (L + 0.433 * B), 130 / (H + 0.25 * B)); // 28.09.2026 mobil Platz sparen: viewBox 440x222 statt 440x270
        var w = L * sc, h = H * sc, dx = 0.433 * B * sc, dy = 0.25 * B * sc;
        var x0 = Math.round((360 - (w + dx)) / 2 + 20), y0 = 182, yt = y0 - h; // rechts 80 px Platz fuer die Breiten-Beschriftung
        var aussen = p.wahl.kantung === KA, r = aussen ? 3 : 0, rim = Math.max(2, Math.min(6, (Number(p.masse.oberkante_breite) || 30) / 12));
        var pt = function (a) { return a.map(function (q) { return q[0].toFixed(1) + ',' + q[1].toFixed(1); }).join(' '); };
        var g = '';
        g += '<polygon points="' + pt([[x0 + w, y0], [x0 + w + dx, y0 - dy], [x0 + w + dx, yt - dy], [x0 + w, yt]]) + '" fill="#8f4a1d"/>';
        g += '<rect x="' + x0 + '" y="' + yt.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" fill="#b5652b"/>';
        g += '<polygon points="' + pt([[x0 - r, yt], [x0 + w + r, yt], [x0 + w + dx + r, yt - dy], [x0 + dx - r, yt - dy]]) + '" fill="#c98548"/>';
        g += '<polygon points="' + pt([[x0 + rim, yt - rim * 0.3], [x0 + w - rim, yt - rim * 0.3], [x0 + w + dx - rim, yt - dy + rim * 0.3], [x0 + dx + rim, yt - dy + rim * 0.3]]) + '" fill="#4a2e1c"/>';
        if (aussen) g += '<line x1="' + (x0 - r) + '" y1="' + (yt + 2).toFixed(1) + '" x2="' + (x0 + w + r) + '" y2="' + (yt + 2).toFixed(1) + '" stroke="#6b3814" stroke-width="2"/>';
        // Masslinien
        var yl = y0 + 16;
        g += '<path class="km-hb__linie" d="M' + x0 + ' ' + (yl - 4) + 'v8M' + (x0 + w).toFixed(1) + ' ' + (yl - 4) + 'v8M' + x0 + ' ' + yl + 'H' + (x0 + w).toFixed(1) + '"/>';
        g += '<text class="km-hb__mass" x="' + (x0 + w / 2).toFixed(1) + '" y="' + (yl + 15) + '" text-anchor="middle">Länge ' + zahl(L) + ' ' + ein + '</text>';
        var xh = x0 - 14;
        g += '<path class="km-hb__linie" d="M' + (xh - 4) + ' ' + yt.toFixed(1) + 'h8M' + (xh - 4) + ' ' + y0 + 'h8M' + xh + ' ' + yt.toFixed(1) + 'V' + y0 + '"/>';
        g += '<text class="km-hb__mass" x="' + (xh - 8) + '" y="' + ((yt + y0) / 2).toFixed(1) + '" text-anchor="middle" transform="rotate(-90 ' + (xh - 8) + ' ' + ((yt + y0) / 2).toFixed(1) + ')">Höhe ' + zahl(H) + ' ' + ein + '</text>';
        var bx = x0 + w + 8, by = y0 + 4;
        g += '<path class="km-hb__linie" d="M' + bx.toFixed(1) + ' ' + by + 'L' + (bx + dx).toFixed(1) + ' ' + (by - dy).toFixed(1) + '"/>';
        g += '<text class="km-hb__mass" x="' + Math.min(bx + dx / 2 + 8, 338).toFixed(1) + '" y="' + (by - dy / 2 + 14).toFixed(1) + '">Breite ' + zahl(B) + ' ' + ein + '</text>';
        var liter = ein === 'cm' ? L * B * H / 1000 : L * B * H / 1e6;
        g += '<text x="10" y="18">Blech ' + e(p.wahl.blech) + ' mm · Kante ' + (aussen ? 'nach außen' : 'nach innen') + '</text>'; // Volumen steht in der Befüllung (28.09.2026, weniger Doppelangaben)
        box.innerHTML = g;
      }
      // Gewicht und Erdbedarf (Martin 27.09.2026). Gewicht: abgewickelte Wand (Höhe + Oberkante Breite + Höhe
      // + Unterkante 30 mm) je Umfang, dazu der Boden; Dichte aus der Preisformel. Versteifungsprofil nicht
      // enthalten, daher "ca.". Schichten nach dem Hochbeet-Ratgeber: Drainage 20-30, Grün, Kompost, Pflanzerde je
      // 15-20 cm; niedrige Beete (unter 65 cm Füllhöhe) Kies/Blähton 10 cm, Vlies, Pflanzerde.
      var info = root.querySelector('[data-km-hb-info]');
      if (info && FORMEL.form === 'holzlager') {
        // Holzlager: Gewicht aus Rahmen (2 x (Breite + Hoehe) x Tiefe), Kante vorn und hinten, Rueckwand; Stauraum nach Innenmass
        var fkh = Number(FORMEL.faktor) || 1, rh = Number(FORMEL.material && FORMEL.material[0]) || 7850;
        var hB = Number(p.masse.laenge) * fkh / 1000, hH = Number(p.masse.breite) * fkh / 1000, hT = Number(p.masse.hoehe) * fkh / 1000;
        var ht = (Number(p.wahl.blech) || 2) / 1000, hk = (Number(p.masse.kantung_mass) || 50) / 1000, hr = FORMEL.boden && p.wahl.boden === FORMEL.boden[0];
        var hkg = Math.round((2 * (hB + hH) * (hT + 2 * hk) + (hr ? hB * hH : 0)) * ht * rh);
        var hv = Math.max(0, (hB - 2 * ht) * (hH - 2 * ht) * (hT - (hr ? ht : 0)));
        var hvt = hv.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), hvz = hv < 0.1 ? zahl(Math.round(hv * 1000)) + ' Liter' : hvt + ' m³';
        var hbx = info.querySelector('details'), hof = !!(hbx && hbx.open);
        info.innerHTML = '<details class="km-hb-info__box"' + (hof ? ' open' : '') + '><summary><span>Gewicht ca. <strong>' + zahl(hkg) + ' kg</strong> · Stauraum ca. <strong>' + hvz + '</strong></span><span class="km-hb-info__mehr" aria-hidden="true"></span></summary>'
          + '<div class="km-hb-info__body"><p>Leergewicht ohne Holz. Der Stauraum ist nach dem Innenmaß gerechnet und entspricht etwa ' + hvt + ' Raummetern geschichtetem Brennholz.</p></div></details>';
      } else if (info) {
        var fk = Number(FORMEL.faktor) || 1, rho = Number(FORMEL.material && FORMEL.material[0]) || 7850;
        var Lm = Number(p.masse.laenge) * fk / 1000, Bm = Number(p.masse.breite) * fk / 1000, Hm = Number(p.masse.hoehe) * fk / 1000;
        var Tm = (Number(p.wahl.blech) || 2) / 1000, mitBoden = FORMEL.boden && p.wahl.boden === FORMEL.boden[0];
        var obm = (Number(p.masse.oberkante_breite) || 30) / 1000, ohm = (Number(p.masse.oberkante_hoehe) || 20) / 1000;
        var U = 2 * (Lm + Bm), flaeche = U * (Hm + obm + ohm + 0.03) + (mitBoden ? Lm * Bm : 0);
        var Li = (Lm - 2 * Tm) * 100, Bi = (Bm - 2 * Tm) * 100, Hf = (Hm - (mitBoden ? Tm : 0)) * 100;
        var innen = Li * Bi; // Grundflaeche innen in cm²
        if (FORMEL.art === 'hochbeet_lform') {
          // L-Form (04.10.2026): Umfang 2 x (Schenkel 1 + Schenkel 2), Innenfläche Bi x (L1 + L2 - 4 Blech - Bi)
          var L2m = Number(p.masse.laenge2) * fk / 1000;
          U = 2 * (Lm + L2m); flaeche = U * (Hm + obm + ohm + 0.03);
          innen = Bi * ((Lm + L2m - 4 * Tm) * 100 - Bi);
          if (p.masse.laenge3 !== undefined) {
            // U-Form (05.10.2026): Umfang 2 x (L1 + L2 + L3) - 2 x Breite, Innenfläche Bi x (L1 + L2 + L3 - 6 Blech - 2 Bi)
            var L3m = Number(p.masse.laenge3) * fk / 1000;
            U = 2 * (Lm + L2m + L3m) - 2 * Bm; flaeche = U * (Hm + obm + ohm + 0.03);
            innen = Bi * ((Lm + L2m + L3m - 6 * Tm) * 100 - 2 * Bi);
          }
        }
        var kg = Math.round(flaeche * Tm * rho);
        var ltr = function (cm) { return Math.round(innen * cm / 1000); };
        var sch = [];
        if (Hf >= 65) {
          var sd = Math.max(15, Math.min(20, Math.round((Hf - 20) / 3))), dr = Math.round(Hf - 3 * sd);
          sch = [['Pflanzerde', sd], ['Kompost', sd], ['Grünschnitt, Laub, Rasensoden', sd], ['Drainage: Äste, Strauchschnitt, Häckselgut', dr]];
        } else {
          sch = [['Pflanzerde', Math.round(Hf - 10)], ['Drainage: Kies oder Blähton, darüber Vlies', 10]];
        }
        var zeilen = '';
        for (var si = 0; si < sch.length; si++) zeilen += '<li><span>' + e(sch[si][0]) + ' (' + sch[si][1] + ' cm)</span><span>ca. ' + zahl(ltr(sch[si][1])) + ' l</span></li>';
        // 28.09.2026 (Martin): Infos aufklappbar, zu ist nur die Kurzzeile sichtbar. Offen-Zustand bleibt beim Neuzeichnen erhalten.
        var box = info.querySelector('details'), offen = !!(box && box.open);
        info.innerHTML = '<details class="km-hb-info__box"' + (offen ? ' open' : '') + '><summary><span>Gewicht ca. <strong>' + zahl(kg) + ' kg</strong> · Befüllung ca. <strong>' + zahl(ltr(Hf)) + ' Liter</strong></span><span class="km-hb-info__mehr" aria-hidden="true"></span></summary>'
          + '<div class="km-hb-info__body"><p>Leergewicht ohne Befüllung. Getragen wird das leere Beet, befüllt wird erst am endgültigen Standort. Planen Sie für das Aufstellen genügend Helfer oder ein Hebegerät ein.</p>'
          + '<p class="km-hb-info__titel">Schichten von oben nach unten:</p><ul class="km-hb-info__schichten">' + zeilen + '</ul>'
          + '<p class="km-hb-info__link"><a href="/blogs/metallbau-fachwissen-tipps/hochbeet-cortenstahl-ratgeber-planung-befuellung-pflege" target="_blank" rel="noopener">Schichtaufbau im Hochbeet-Ratgeber</a></p></div></details>';
      }
      var kan = root.querySelector('[data-km-hb-kante]');
      if (kan) {
        var ob = Number(p.masse.oberkante_breite) || 30, oh = Number(p.masse.oberkante_hoehe) || 20, t = Number(p.wahl.blech) || 2;
        var k = Math.min(170 / (ob + 10), 110 / (oh + 20), 2.4), tw = Math.max(3, t * k), aus = p.wahl.kantung === KA;
        var xw = aus ? 270 : 150, yo = 40, dir = aus ? -1 : 1, bw = ob * k, hh = oh * k;
        var x2 = xw + dir * bw;
        var q = '';
        q += '<rect x="' + (xw - tw / 2).toFixed(1) + '" y="' + yo + '" width="' + tw.toFixed(1) + '" height="150" fill="#b5652b"/>';
        q += '<rect x="' + Math.min(xw, x2).toFixed(1) + '" y="' + yo + '" width="' + bw.toFixed(1) + '" height="' + tw.toFixed(1) + '" fill="#b5652b"/>';
        q += '<rect x="' + (x2 - (dir > 0 ? tw : 0)).toFixed(1) + '" y="' + yo + '" width="' + tw.toFixed(1) + '" height="' + hh.toFixed(1) + '" fill="#b5652b"/>';
        q += '<path class="km-hb__linie" d="M' + xw + ' ' + (yo - 12) + 'H' + x2.toFixed(1) + 'M' + xw + ' ' + (yo - 16) + 'v8M' + x2.toFixed(1) + ' ' + (yo - 16) + 'v8"/>';
        q += '<text class="km-hb__mass" x="' + ((xw + x2) / 2).toFixed(1) + '" y="' + (yo - 18) + '" text-anchor="middle">Breite ' + zahl(ob) + ' mm</text>';
        var xm = x2 + dir * 14;
        q += '<path class="km-hb__linie" d="M' + xm.toFixed(1) + ' ' + yo + 'V' + (yo + hh).toFixed(1) + 'M' + (xm - 4).toFixed(1) + ' ' + yo + 'h8M' + (xm - 4).toFixed(1) + ' ' + (yo + hh).toFixed(1) + 'h8"/>';
        q += '<text class="km-hb__mass" x="' + (xm + dir * 8).toFixed(1) + '" y="' + (yo + hh / 2 + 4).toFixed(1) + '" text-anchor="' + (dir > 0 ? 'start' : 'end') + '">Höhe ' + zahl(oh) + ' mm</text>';
        q += '<text x="' + (xw - dir * 12) + '" y="' + (yo + 120) + '" text-anchor="' + (dir > 0 ? 'end' : 'start') + '">Blech ' + zahl(t) + ' mm</text>';
        q += '<text x="' + (aus ? 400 : 40) + '" y="200" text-anchor="middle">außen</text><text x="' + (aus ? 40 : 400) + '" y="200" text-anchor="middle">Beet innen</text>';
        q += '<text x="220" y="200" text-anchor="middle">Kante ' + (aus ? 'nach außen' : 'nach innen') + '</text>';
        kan.innerHTML = q;
      }
    }
    function properties(s, p) {
      var props = {};
      // Rabattzeile nicht in den Warenkorb (Martin 19.09.2026): Positionstext geht an den Lieferanten. Preis bleibt rabattiert.
      // Abgewaehlte Optionen (leer: "ohne ...", 0 EUR) kommen nicht in den Warenkorb und damit nicht in den
      // Auftrag (Martin 22.09.2026): was nicht angegeben ist, wird nicht gefertigt.
      for (var i = 0; i < p.zeilen.length; i++) { if (p.zeilen[i].schritt === 'rabatt' || p.zeilen[i].leer) continue; props[p.zeilen[i].key] = p.zeilen[i].value; }
      if (s.bemerkung && R.bemerkung) props[R.bemerkung.key] = s.bemerkung;
      var bildKey = renderKey(bildWahl(p)), bildId = bildKey ? MEDIA[bildKey] : null;
      var bild = (bildId && MEDIA_URL[bildId]) || CTX.bild || (MODELL && MODELL.bilder && MODELL.bilder.foto) || null;
      if (bild) props['_km_bild'] = bild;
      props['_km_preis'] = p.total.toFixed(2);
      props['_km_konfig'] = JSON.stringify(konfig(s));
      return props;
    }
    function konfig(s) {
      // Nur sichtbare Schritte mitgeben - versteckte behalten sonst alte Werte
      var p = kmAusstattungPreis(R, s, menge()), k = { t: 'ausstattung' };
      if (!p) return k;
      for (var i = 0; i < SCHRITTE.length; i++) {
        var step = SCHRITTE[i];
        if (!p.sicht[step]) continue;
        k[step] = s[step];
        // Freie Eingabe mitgeben (Sonderfarbe): konfig() ist auch _km_konfig - ohne den Text
        // baut die Function den Positionstext aus dem Label statt aus dem Farbton.
        var wko = wahlOption(R[step]);
        if (wko && s[step] === wko.id && s[step + '_wunsch']) k[step + '_wunsch'] = s[step + '_wunsch'];
      }
      if (s.bemerkung) k.bemerkung = s.bemerkung;
      return k;
    }
    function encode(s) { return btoa(unescape(encodeURIComponent(JSON.stringify(konfig(s))))).replace(/=+$/, ''); }
    function decode(str) { try { return JSON.parse(decodeURIComponent(escape(atob(str)))); } catch (e) { return null; } }
    var nutzerAendert = false; // Deep-Link erst schreiben, wenn der Besucher etwas geaendert hat
    var linkTimer = null;
    function deepLink(s) {
      if (!nutzerAendert) return;
      if (linkTimer) clearTimeout(linkTimer);
      linkTimer = setTimeout(function () {
        linkTimer = null;
        try { history.replaceState(null, '', location.pathname + location.search + '#konf=' + encode(s)); } catch (e) {}
      }, 500);
    }

    /* ================= Galerie (Vordach: Bild je Größe/Farbe, Muster km-gelaender.js) ================= */
    // Schlüssel in custom.km_medien: die Wahl der Schritte aus R.medien.schluessel mit "|" verbunden
    // ("2500x1155|ral7016", Landau "zugstangen|2500x1155|ral7016"); Rückfall auf weniger Teile.
    // Nur aktiv, wenn R.medien existiert - Köln bleibt unverändert.
    var galerieBereit = false, aktuellerKey = null;
    // Vorschau im Schritt (19.09.2026, Martin: mobil sieht man die Galerie nicht): ein Bild
    // unter den Karten des offenen Schritts, das Rendering bzw. der Maßzeichnung folgt.
    // Nur mit Medienzuordnung (Vordach); CSS .km-mini zeigt es erst unter 990 px.
    var mini = null, miniErlaubt = true;
    // Vorschau nur in den Schritten, die das Bild bestimmen (medien.schluessel, z. B. Größe und Farbe Dach)
    // oder die Maßzeichnung tragen - Martin 19.09.2026: "rest ohne Vorschaubild".
    function miniSchritt(name) {
      if (!R.medien || !name) return false;
      if ((R.medien.schluessel || []).indexOf(name) >= 0) return true;
      return zeichnungSchritt(name);
    }
    // Schritte, die die Masszeichnung zeigen: Teil des Zeichnungsschluessels (Designtak: Groesse) oder in
    // medien.zeichnung_bei (Portal 20.09.2026: Breite, Tiefe, Hoehe - Martin: "bei Klick auf Masseingabe")
    function zeichnungSchritt(name) {
      if (!R.medien || !name) return false;
      if (String(R.medien.zeichnung || '').indexOf('<' + name + '>') >= 0) return true;
      return (R.medien.zeichnung_bei || []).indexOf(name) >= 0;
    }
    // Bleibt der Zeichnungsmodus bei einer Aenderung aus diesem Schritt an? Mit zeichnung_bei (Portal) nur bei
    // den Massfeldern - die Seitenteil-Auswahl holt das Rendering zurueck; ohne (Designtak) bei den Schluessel-
    // Schritten (Groesse).
    function zeichnungBleibt(name) {
      if (!R.medien || !name) return false;
      var bei = R.medien.zeichnung_bei;
      if (bei && bei.length) return bei.indexOf(name) >= 0;
      return String(R.medien.zeichnung || '').indexOf('<' + name + '>') >= 0;
    }
    function miniAnlegen() {
      if (!R.medien || !Object.keys(MEDIA).length) return;
      mini = document.createElement('figure');
      mini.className = 'km-mini km-mini--ausstattung';
      mini.innerHTML = '<button type="button" class="km-mini__zoom" aria-label="Vorschau vergrößern"><img class="km-mini__bild" alt="" loading="lazy" width="400" height="300"><span class="km-mini__lupe" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6"/></svg></span></button><figcaption class="km-mini__text"></figcaption>';
      mini.querySelector('.km-mini__zoom').addEventListener('click', zoomOeffnen);
      var erstes = document.querySelector('.product__media-item img');
      var src = erstes ? (erstes.currentSrc || erstes.src) : '';
      if (src) miniSetzen(src, 'Produktbild – das Vorschaubild folgt Ihrer Auswahl'); else mini.hidden = true;
    }
    function miniSetzen(src, text) {
      if (!mini) return;
      var img = mini.querySelector('img'), cap = mini.querySelector('figcaption');
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      if (cap) cap.textContent = text || '';
      mini.hidden = !src || !miniErlaubt;
    }
    function miniInSchritt(schritt) {
      if (!mini || !schritt) return;
      miniErlaubt = miniSchritt(schritt.getAttribute('data-step'));
      if (!miniErlaubt) { mini.hidden = true; return; }
      var body = schritt.querySelector('.km-step__body'); if (!body) return;
      if (mini.parentNode !== body) body.appendChild(mini);
      mini.hidden = !mini.querySelector('img').getAttribute('src');
    }
    function miniSichtbar() { return !!(mini && !mini.hidden && mini.offsetParent); }
    // Zoom (Martin 19.09.2026, nach V73): Tap auf die Vorschau öffnet das Bild im Vollbild (1600 px statt 400 px),
    // Tap aufs Bild schaltet zwischen Einpassen und 2-fach (scrollbar), X / Hintergrund / Escape schließen.
    var zoom = null;
    function zoomUrl(src) { return String(src).replace(/([?&])width=\d+/, '$1width=1600'); }
    function zoomOeffnen() {
      if (!mini) return;
      var img = mini.querySelector('img'), src = img && img.getAttribute('src'); if (!src) return;
      if (!zoom) {
        zoom = document.createElement('div');
        zoom.className = 'km-zoom'; zoom.setAttribute('role', 'dialog'); zoom.setAttribute('aria-modal', 'true'); zoom.setAttribute('aria-label', 'Vorschau vergrößert');
        zoom.innerHTML = '<div class="km-zoom__flaeche"><img class="km-zoom__bild" alt=""></div><p class="km-zoom__text"></p><button type="button" class="km-zoom__close" aria-label="Schließen"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
        document.body.appendChild(zoom);
        zoom.querySelector('.km-zoom__close').addEventListener('click', zoomSchliessen);
        zoom.querySelector('.km-zoom__flaeche').addEventListener('click', function (e) { if (e.target === e.currentTarget) zoomSchliessen(); });
        zoom.querySelector('.km-zoom__bild').addEventListener('click', function () { zoom.classList.toggle('is-gross'); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && zoom && !zoom.hidden) zoomSchliessen(); });
      }
      zoom.querySelector('.km-zoom__bild').setAttribute('src', zoomUrl(src));
      zoom.querySelector('.km-zoom__text').textContent = (mini.querySelector('figcaption').textContent || '') + ' – Tippen zum Vergrößern';
      zoom.classList.remove('is-gross'); zoom.hidden = false; document.body.classList.add('km-modal-open');
      zoom.querySelector('.km-zoom__close').focus();
    }
    function zoomSchliessen() {
      if (!zoom) return;
      zoom.hidden = true; document.body.classList.remove('km-modal-open');
      var b = mini && mini.querySelector('.km-mini__zoom'); if (b) b.focus();
    }
    function selectMedia(id) {
      if (MEDIA_URL[id]) miniSetzen(MEDIA_URL[id], zeichnungAktiv ? 'Maßzeichnung zur gewählten Größe' : 'Vorschau Ihrer Konfiguration');
      var item = document.querySelector('.product__media-item[data-media-id="' + id + '"]');
      var car = document.querySelector('flickity-carousel.product__media-list, .product__media-list');
      var thumb = document.querySelector('.product__thumbnail-item[data-media-id="' + id + '"]');
      var fallback = function () { if (thumb) thumb.click(); };
      if (!item || !car) { fallback(); return; }
      var inst = car.flickityInstance || (window.Flickity && window.Flickity.data(car));
      if (!inst) { fallback(); return; }
      Promise.resolve(inst).then(function (f) {
        if (f && typeof f.selectCell === 'function') f.selectCell(item, false, true); else fallback();
      }).catch(fallback);
    }
    // Bildwahl: die aufgeloeste Wahl, ausgeblendete Schritte zaehlen als "ohne" (Portal: bei "1x Stuetze links"
    // traegt eckstuetze_rechts noch die erste Option, das Rendering soll aber nur die linke Stuetze zeigen).
    function bildWahl(p) {
      if (!p || !p.wahl) return null;
      var w = {}; for (var k in p.wahl) w[k] = (p.sicht && R[k] && R[k].optionen && !p.sicht[k]) ? 'ohne' : p.wahl[k];
      // Modelle ohne Eckstuetzen-Schritt (Tragwerk): Pfosten im Bild folgt der Variante
      var va = String(w.seitenteil || '');
      // Platin ab Tiefe 1.400 (14.10.2026): Eckstuetzen-Schritt ausgeblendet (Stuetzen inklusive) - Pfosten ebenfalls aus der Variante
      if ((!R.eckstuetze_links || !(p.sicht && p.sicht.eckstuetze_links)) && va) w.eckstuetze_links = /stuetze-links|stuetze-beide/.test(va) ? 'pfosten' : 'ohne';
      if ((!R.eckstuetze_rechts || !(p.sicht && p.sicht.eckstuetze_rechts)) && va) w.eckstuetze_rechts = /stuetze-rechts|stuetze-beide/.test(va) ? 'pfosten' : 'ohne';
      return w;
    }
    function renderKey(wahl) {
      if (!R.medien || !(R.medien.schluessel instanceof Array) || !wahl) return null;
      var teile = [];
      for (var i = 0; i < R.medien.schluessel.length; i++) {
        var st = R.medien.schluessel[i], v = wahl[st]; if (v === undefined || v === null || v === '') break;
        // Portal (bild_nach_typ): Schluesselteil = option.bild_typ (geschlossen|sprossen|glas), sonst die Options-ID
        if (R.medien.bild_nach_typ && R[st] && R[st].optionen) { var bo = findeId(R[st].optionen, v); if (bo && bo.bild_typ) v = bo.bild_typ; }
        teile.push(String(v));
      }
      for (var n = teile.length; n > 0; n--) { var key = teile.slice(0, n).join('|'); if (MEDIA[key]) return key; }
      return null;
    }
    // Zeichnungsmodus (Knopf data-km-zeichnung, 19.09.2026): solange er aktiv ist, folgt die Galerie
    // der Maßzeichnung der gewählten Größe; jede andere Änderung (Farbe usw.) beendet ihn und zeigt
    // wieder das Rendering.
    var zeichnungAktiv = false, aktuelleZeichnung = null, letzterSchritt = null;
    function zeichnungKnopfText() {
      root.querySelectorAll('[data-km-zeichnung]').forEach(function (b) {
        var t = b.querySelector('span'); if (t) t.textContent = b.getAttribute(zeichnungAktiv ? 'data-label-aus' : 'data-label-an') || t.textContent;
        b.setAttribute('aria-pressed', zeichnungAktiv ? 'true' : 'false');
      });
    }
    function showRender(wahl) {
      var key = renderKey(wahl);
      if (zeichnungAktiv) {
        var zk = zeichnungKey(wahl);
        // Größe gewechselt: Zeichnung der neuen Größe zeigen, Modus bleibt an. Kam der Wechsel aus einem
        // anderen Schritt (Portal: Seitenteil-Auswahl aendert die Zeichnung), Modus beenden und Rendering zeigen.
        if (zk && zk !== aktuelleZeichnung && zeichnungBleibt(letzterSchritt)) { aktuelleZeichnung = zk; aktuellerKey = key; if (galerieBereit) selectMedia(MEDIA[zk]); return; }
        if (!key || key === aktuellerKey) return;
        // andere Änderung (z. B. Farbe): Zeichnungsmodus beenden, Rendering zeigen
        zeichnungAktiv = false; aktuelleZeichnung = null; zeichnungKnopfText();
      }
      if (!key || key === aktuellerKey) return;
      aktuellerKey = key;
      if (!galerieBereit) return;
      selectMedia(MEDIA[key]);
    }
    // Die Konfigurationsbilder stehen nicht als zusätzliche Thumbnails in der Galerie -
    // sie erscheinen nur über die Konfiguration.
    function renderThumbsVerstecken() {
      if (!R.medien) return;
      Object.keys(MEDIA).forEach(function (k) {
        var t = document.querySelector('.product__thumbnail-item[data-media-id="' + MEDIA[k] + '"]');
        if (t) t.classList.add('km-render-thumb');
      });
    }
    // Maßzeichnung (R.medien.zeichnung, z. B. "zeichnung|<groesse>") beim Öffnen des Schritts,
    // der im Schlüssel vorkommt. Das Rendering kommt zurück, sobald sich sein Schlüssel ändert.
    function zeichnungKey(wahl) {
      var v = R.medien && R.medien.zeichnung; if (!v || !wahl) return null;
      var key = String(v).replace(/<([a-z0-9_]+)>/gi, function (m, st) { return wahl[st] === undefined ? m : String(wahl[st]); });
      // Zeichnung je Rahmenrinnenprofil (14.10.2026): "zeichnung|ohne|245", wenn hinterlegt, sonst der Grundschlüssel
      if (wahl.profil && MEDIA[key + '|' + wahl.profil]) return key + '|' + wahl.profil;
      return MEDIA[key] ? key : null;
    }
    function zeichnungZeigen(stepName) {
      var v = R.medien && R.medien.zeichnung; if (!v || !galerieBereit || !stepName) return;
      if (!zeichnungSchritt(stepName)) return;
      var p = kmAusstattungPreis(R, state(), menge()); if (!p) return;
      var key = zeichnungKey(p.wahl); if (!key) return;
      aktuellerKey = renderKey(bildWahl(p)); aktuelleZeichnung = key;
      selectMedia(MEDIA[key]);
    }
    // Klick/Fokus ins Massfeld (Portal): Zeichnungsmodus an wie beim Knopf - die Galerie folgt der Zeichnung,
    // bis eine andere Wahl (Seitenteil, Farbe) das Rendering zurueckholt. Mobil scrollt die Galerie ins Bild.
    root.querySelectorAll('.km-f__mass').forEach(function (feld) {
      feld.addEventListener('focus', function () {
        var step = feld.closest('.km-step'); var name = step ? step.getAttribute('data-step') : null;
        if (!zeichnungSchritt(name) || !galerieBereit) return;
        var p = kmAusstattungPreis(R, state(), menge()); if (!p) return;
        var key = zeichnungKey(p.wahl); if (!key) return;
        zeichnungAktiv = true; zeichnungKnopfText();
        aktuellerKey = renderKey(bildWahl(p)); aktuelleZeichnung = key;
        selectMedia(MEDIA[key]);
        galerieInsBild();
      });
    });
    // Knopf "Maßzeichnung dieser Größe anzeigen" / "Produktbild anzeigen" (Martin 19.09.2026). Auf dem
    // Handy liegt die Galerie über dem Konfigurator - dann dorthin scrollen, sonst sieht man nichts.
    function galerieInsBild() {
      if (miniSichtbar()) return; // mobil steht das Bild direkt im Schritt
      var g = document.querySelector('.product__media, .product__media-list'); if (!g) return;
      var r = g.getBoundingClientRect();
      if (r.bottom < 60 || r.top > window.innerHeight * 0.6) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.querySelectorAll('[data-km-zeichnung]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.closest('.km-step'); var name = step ? step.getAttribute('data-step') : null;
        var p = kmAusstattungPreis(R, state(), menge()); if (!p) return;
        if (zeichnungAktiv) {
          zeichnungAktiv = false; aktuelleZeichnung = null; zeichnungKnopfText();
          var rk = renderKey(bildWahl(p)); aktuellerKey = rk; if (rk) selectMedia(MEDIA[rk]); else { var erstes = document.querySelector('.product__thumbnail-item'); if (erstes) erstes.click(); }
          return;
        }
        var key = zeichnungKey(p.wahl); if (!key) return;
        zeichnungAktiv = true; zeichnungKnopfText();
        aktuellerKey = renderKey(bildWahl(p)); aktuelleZeichnung = key;
        selectMedia(MEDIA[key]);
        galerieInsBild();
      });
    });

    /* ================= Anzeige ================= */
    function update() {
      var s = state();
      if (sichtbarkeit(s)) s = state();
      var p = kmAusstattungPreis(R, s, menge());
      var ok = !!p;
      optionPreise(p ? p.wahl : null, p ? p.modell : null, p ? p.ctx : null);
      if (p) showRender(bildWahl(p));
      if (p) hbSkizzen(p);
      if (p && MODUL && nutzerAendert && tiaGal) tiaGalerieZeigen(tiaGal.zellen[0], false);
      var stueck = menge();
      var mengenRabatt = mengenStaffel(s, p, stueck);
      var total = p ? Math.round(p.total * TAXF * 100) / 100 * stueck : 0;
      var listenpreis = p ? Math.round(p.listenpreis * TAXF * 100) / 100 * stueck : 0;
      total = Math.round(total * 100) / 100; listenpreis = Math.round(listenpreis * 100) / 100;
      els.total.textContent = ok ? fmt(total) : '–';
      if (els.streich) {
        // Streichpreis nur bei Aktionsrabatt (R.rabatt) - Koeln ohne rabatt zeigt keinen
        var rabattAktiv = ok && p.rabatt_prozent > 0;
        els.streich.textContent = rabattAktiv ? fmt(listenpreis) : '';
        els.streich.hidden = !rabattAktiv;
      }
      if (els.netto) {
        if (ok && TAXSATZ !== null && TAXSATZ > 0) {
          var nbsp = String.fromCharCode(160);
          els.netto.textContent = fmt(total / (1 + TAXSATZ / 100)) + nbsp + 'netto zzgl.' + nbsp + TAXSATZ + nbsp + '%' + nbsp + 'MwSt.';
          els.netto.hidden = false;
        } else els.netto.hidden = true;
      }
      if (els.liste) {
        var zeilen = [];
        var f = function (x) { return Math.round(x * TAXF * 100) / 100; };
        function zeile(bez, betrag, klasse) {
          zeilen.push('<li class="km-pos' + (klasse ? ' ' + klasse : '') + '"><span class="km-pos__bez">' + esc(bez) + '</span><span class="km-pos__wert">' + esc(betrag) + '</span></li>');
        }
        if (ok) {
          for (var i = 0; i < p.zeilen.length; i++) {
            var z = p.zeilen[i];
            if (z.schritt === 'modell') { zeile(R.familie + ' ' + z.value, z.betrag > 0 ? fmt(f(z.betrag)) : ''); continue; } // Vordach: Grundpreis steckt in der Groesse, Modellzeile ohne 0,00
            if (z.schritt === 'bemerkung' || z.leer) continue;
            if (z.schritt === 'info') { zeile(z.label + ': ' + z.value, '', 'km-pos--info'); continue; } // Portal: Rahmenrinnenprofil, Stuetzen inklusive
            if (R[z.schritt] && R[z.schritt].typ === 'mass') { zeile(z.label + ': ' + z.value, '', 'km-pos--mass'); continue; } // Portal: Masse ohne "inkl."
            if (z.schritt === 'rabatt') { zeile(z.label + ' ' + '−' + p.rabatt_prozent + ' %', '−' + fmt(f(p.listenpreis - p.total)), 'km-pos--rabatt'); continue; } // Aktionsrabatt: „Aktionsrabatt −5 %“ / „−134,25 €“ direkt vor dem Gesamtpreis
            zeile(z.label + ': ' + z.value, z.betrag > 0 ? fmt(f(z.betrag)) : 'inkl.');
          }
          // Stueckzahl (R.menge): Stueckpreis je Einheit, der Gesamtpreis darunter gilt fuer alle Stueck
          if (R.menge && stueck > 1) zeile(R.menge.label + ': ' + stueck + ' × ' + fmt(f(p.total)) + (mengenRabatt > 0 ? ' (−' + mengenRabatt + ' % Mengenrabatt)' : ''), fmt(total), 'km-pos--menge');
        } else zeile('Konfiguration (Regelwerk prüfen)', '–');
        els.liste.innerHTML = zeilen.join('');
      }
      if (els.flag) els.flag.hidden = !(R.preis_status === 'vorlaeufig');
      var offen = schritteZeichnen(s, ok);
      var frei = ok && offen.length === 0;
      if (els.add) {
        els.add.classList.toggle('km-btn--gesperrt', !frei);
        els.add.setAttribute('aria-disabled', frei ? 'false' : 'true');
      }
      if (els.msg) {
        // 19.09.2026: Die rote Zeile erscheint erst nach einem Klick auf den gesperrten Knopf
        // (data-km-auswahl) und folgt dann der Auswahl - vorher stand sie dauerhaft unter
        // "Noch offen: ..." mit demselben Inhalt, zweimal dieselbe Liste.
        if (!frei && offen.length) {
          if (els.msg.getAttribute('data-km-auswahl')) { els.msg.textContent = 'Bitte gehen Sie noch durch: ' + offen.join(', ') + '.'; els.msg.className = 'km-msg is-err'; }
        } else if (els.msg.getAttribute('data-km-auswahl')) {
          els.msg.textContent = ''; els.msg.className = 'km-msg'; els.msg.removeAttribute('data-km-auswahl');
        }
      }
      deepLink(s);
      stickyZeichnen(ok, frei, offen, total, ok && p.rabatt_prozent > 0 ? listenpreis : 0);
      return { s: s, p: p, ok: ok, frei: frei, offen: offen, total: total };
    }

    /* ================= Schrittfolge (Akkordeon + Leiste) ================= */
    var schritte = [].slice.call(root.querySelectorAll('.km-step'));
    var beruehrt = {};
    function haken(px) {
      return '<svg viewBox="0 0 24 24" width="' + px + '" height="' + px + '" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';
    }
    function wertText(name, s, p) {
      var def = R[name]; if (!def || !p) return '';
      if (def.mehrfach) { var n = 0; for (var i = 0; i < p.zeilen.length; i++) if (p.zeilen[i].schritt === name) n++; return n ? n + ' Position' + (n > 1 ? 'en' : '') + ' gewählt' : 'Kein Zubehör'; }
      var text = '';
      for (var j = 0; j < p.zeilen.length; j++) if (p.zeilen[j].schritt === name) { text = p.zeilen[j].value; break; }
      // Massfelder anderer Schritte im selben Abschnitt (def.mit, Portal "Breite und Tiefe"): "2000 × 1000 mm"
      if (text && def.mit) for (var m = 0; m < def.mit.length; m++) { var mt = ''; for (var k = 0; k < p.zeilen.length; k++) if (p.zeilen[k].schritt === def.mit[m]) { mt = p.zeilen[k].value; break; } if (mt) text = text.replace(/ (mm|cm)$/, '') + ' × ' + mt; }
      return text;
    }
    function erledigt(schritt, name) {
      var def = R[name];
      // Freie Eingabe gewaehlt (Sonderfarbe): der Schritt ist erst fertig, wenn etwas drinsteht
      var wo = wahlOption(def);
      if (wo && wert(name) === wo.id && !String(wert(name + '_wunsch') || '').replace(/^\s+|\s+$/g, '')) return false;
      if (def && def.mehrfach) return !!beruehrt[name];      // Zubehör: bewusst angesehen reicht
      if (def && def.typ === 'text') return !!beruehrt[name]; // Farbe: Standard gilt, aber angesehen
      return !!beruehrt[name];
    }
    // Galerie: ein Schritt kann ein Produktmedium benennen (data-galerie-bild = Dateiname ohne
    // Endung). Beim Oeffnen springt die Galerie dorthin, beim Schliessen zurueck zum ersten Bild.
    function thumbMit(dateiname) {
      var thumbs = document.querySelectorAll('.product__thumbnail-item');
      for (var i = 0; i < thumbs.length; i++) {
        var img = thumbs[i].querySelector('img'); var src = img ? (img.currentSrc || img.src || img.getAttribute('data-src') || '') : '';
        if (src.indexOf(dateiname) >= 0) return thumbs[i];
      }
      return null;
    }
    // Option mit eigenem Galeriebild (Köln Holzverkleidung, Martin 16.10.2026): Wahl der Option springt zum
    // Bild, Wechsel auf eine Option ohne Bild zurueck zum ersten Bild. Quelle: GAL_OPT (Medien-ID) oder
    // option.galerie_bild (Dateiname). Ueber den Slider, damit es auch mobil ohne Thumbnail-Leiste greift.
    function medienIdMit(dateiname) {
      var items = document.querySelectorAll('.product__media-item[data-media-id]');
      for (var i = 0; i < items.length; i++) {
        var img = items[i].querySelector('img'); if (!img) continue;
        var src = img.currentSrc || img.src || img.getAttribute('data-src') || img.getAttribute('srcset') || '';
        if (src.indexOf(dateiname) >= 0) return items[i].getAttribute('data-media-id');
      }
      var t = thumbMit(dateiname); return t ? t.getAttribute('data-media-id') : null;
    }
    function optionBild(o) {
      if (!o) return null;
      if (GAL_OPT[o.id]) return String(GAL_OPT[o.id]);
      return o.galerie_bild ? medienIdMit(o.galerie_bild) : null;
    }
    function galerieOption(st) {
      if (!galerieBereit || !st || !R[st] || !(R[st].optionen instanceof Array)) return;
      if (!R[st].optionen.some(function (o) { return !!(o.galerie_bild || GAL_OPT[o.id]); })) return;
      var id = optionBild(findeId(R[st].optionen, wert(st)));
      if (id) { selectMedia(id); galerieGezeigt = 'option:' + id; return; }
      if (galerieGezeigt) { var erstes = document.querySelector('.product__media-item[data-media-id]'); if (erstes) selectMedia(erstes.getAttribute('data-media-id')); galerieGezeigt = null; }
    }
    var galerieGezeigt = null;
    function galerieZeigen(schritt, auf) {
      var name = schritt.getAttribute('data-galerie-bild'); if (!name) return;
      if (auf) { var t = thumbMit(name); if (t) { t.click(); galerieGezeigt = name; } }
      else if (galerieGezeigt === name) { var erstes = document.querySelector('.product__thumbnail-item'); if (erstes) erstes.click(); galerieGezeigt = null; }
    }
    function aufklappen(schritt, auf, merken) {
      var knopf = schritt.querySelector('.km-step__toggle'), koerper = schritt.querySelector('.km-step__body');
      var war = schritt.classList.contains('is-offen');
      knopf.setAttribute('aria-expanded', auf ? 'true' : 'false'); koerper.hidden = !auf;
      schritt.classList.toggle('is-offen', auf);
      if (auf && merken !== false) { var name = schritt.getAttribute('data-step'); if (name) beruehrt[name] = true; }
      if (auf) miniInSchritt(schritt);
      if (auf !== war && merken !== false) galerieZeigen(schritt, auf);
      if (auf && auf !== war && merken !== false) zeichnungZeigen(schritt.getAttribute('data-step'));
    }
    function sichtbareSchritte() { return schritte.filter(function (x) { return !x.hidden; }); }
    function aktive() { var l = sichtbareSchritte(); for (var i = 0; i < l.length; i++) if (l[i].classList.contains('is-offen')) return l[i]; return null; }
    function naechsterOffener(ab) {
      var l = sichtbareSchritte(), start = ab ? l.indexOf(ab) + 1 : 0;
      for (var i = start; i < l.length; i++) if (!erledigt(l[i], l[i].getAttribute('data-step'))) return l[i];
      for (var j = start; j < l.length; j++) return l[j];
      return null;
    }
    function schritteZeichnen(s, ok) {
      var p = ok ? kmAusstattungPreis(R, s, menge()) : null;
      var nr = 0, offeneNamen = [], punkte = '', ersterOffenNr = 0;
      sichtbareSchritte().forEach(function (schritt) {
        var name = schritt.getAttribute('data-step');
        nr += 1;
        var fertig = erledigt(schritt, name);
        if (!fertig) { offeneNamen.push(schritt.querySelector('.km-step__titel').textContent.trim()); if (!ersterOffenNr) ersterOffenNr = nr; }
        schritt.querySelector('.km-step__nr').textContent = nr;
        var wahl = schritt.querySelector('.km-step__wahl');
        wahl.textContent = fertig ? wertText(name, s, p) : 'Bitte wählen';
        wahl.classList.toggle('is-hinweis', !fertig);
        schritt.classList.toggle('is-fertig', fertig);
        var status = schritt.querySelector('[data-step-status]');
        status.className = 'km-step__status ' + (fertig ? 'is-fertig' : 'is-offen');
        status.innerHTML = fertig ? haken(13) : '';
        punkte += '<span class="km-fortschritt__punkt' + (fertig ? ' is-fertig' : '') + '">' + (fertig ? haken(11) : nr) + '</span>';
      });
      if (els.leiste) {
        var text = els.leiste.querySelector('[data-fortschritt-text]');
        var pk = els.leiste.querySelector('[data-fortschritt-punkte]');
        var weiter = els.leiste.querySelector('[data-fortschritt-weiter]');
        if (text) text.textContent = offeneNamen.length === 0 ? 'Alle ' + nr + ' Schritte erledigt' : 'Schritt ' + ersterOffenNr + ' von ' + nr;
        if (pk) pk.innerHTML = punkte;
        if (weiter) weiter.hidden = offeneNamen.length === 0;
      }
      if (els.offen) {
        if (offeneNamen.length) { els.offen.textContent = 'Noch offen: ' + offeneNamen.join(', '); els.offen.hidden = false; }
        else els.offen.hidden = true;
      }
      return offeneNamen;
    }
    schritte.forEach(function (schritt) {
      schritt.querySelector('.km-step__toggle').addEventListener('click', function () {
        var war = schritt.classList.contains('is-offen');
        var vorher = schritt.getBoundingClientRect().top;
        schritte.forEach(function (x) { aufklappen(x, false); });
        aufklappen(schritt, !war);
        update();
        var diff = schritt.getBoundingClientRect().top - vorher;
        if (Math.abs(diff) > 2) window.scrollBy(0, diff);
      });
    });
    if (els.leiste) {
      var weiterKnopf = els.leiste.querySelector('[data-fortschritt-weiter]');
      if (weiterKnopf) weiterKnopf.addEventListener('click', function () {
        var ziel = naechsterOffener(aktive()) || naechsterOffener(null); if (!ziel) return;
        schritte.forEach(function (x) { aufklappen(x, false); }); aufklappen(ziel, true); update();
        ziel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      // 19.09.2026: Leiste steht seit 07.09. fest ueber dem ersten Schritt (position: static).
      // Der fruehere IntersectionObserver (Ein-/Ausblenden je nach Sichtbarkeit des Formulars)
      // liess das Formular beim Scrollen um die Leistenhoehe springen - deshalb immer sichtbar.
      els.leiste.hidden = false;
    }

    /* ================= Sticky-Leiste (mobil) ================= */
    // 19.09.2026 (Martin): Preis und Warenkorb-Knopf liegen mobil weit unter den Schritten -
    // beim Konfigurieren sieht niemand, was die Wahl kostet. Schmale Leiste am unteren Rand
    // mit Gesamtpreis und dem nächsten Schritt; sie erscheint, sobald das Formular im Bild ist,
    // und verschwindet, sobald der echte Knopfblock (.km-actions) sichtbar wird. CSS blendet
    // sie ab 990 px aus, dort stehen Preis und Knöpfe ohnehin neben der Galerie.
    // Martin 19.09.2026 abends: "frisst zu viel Platz" - Leiste auf eine Zeile (~46 px) geschrumpft;
    // STICKY_LEISTE = false schaltet sie ganz ab.
    var STICKY_LEISTE = true;
    var sticky = null, stickyFormImBild = false, stickyActionsImBild = false, stickyStand = null;
    (function stickyInit() {
      if (!STICKY_LEISTE || !('IntersectionObserver' in window) || !els.add) return;
      var actions = root.querySelector('.km-actions'); if (!actions) return;
      sticky = document.createElement('div');
      sticky.className = 'km-sticky'; sticky.hidden = true; sticky.setAttribute('aria-hidden', 'true');
      sticky.innerHTML = '<span class="km-sticky__preis"><strong class="km-sticky__total"></strong><s class="km-sticky__streich" hidden></s><small>inkl. MwSt.</small></span><button type="button" class="km-sticky__btn"></button>';
      root.appendChild(sticky);
      sticky.querySelector('.km-sticky__btn').addEventListener('click', function () {
        if (stickyStand && stickyStand.frei) { els.add.click(); return; }
        var ziel = naechsterOffener(aktive()) || naechsterOffener(null); if (!ziel) return;
        schritte.forEach(function (x) { aufklappen(x, false); }); aufklappen(ziel, true); update();
        ziel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { if (e.target === form) stickyFormImBild = e.isIntersecting; if (e.target === actions) stickyActionsImBild = e.isIntersecting; });
        stickySichtbarkeit();
      }, { threshold: 0 });
      io.observe(form); io.observe(actions);
    })();
    function stickySichtbarkeit() {
      if (!sticky) return;
      var zeigen = stickyFormImBild && !stickyActionsImBild && !!stickyStand && stickyStand.ok;
      sticky.hidden = !zeigen; sticky.setAttribute('aria-hidden', zeigen ? 'false' : 'true');
      root.classList.toggle('has-sticky', zeigen);
    }
    function stickyZeichnen(ok, frei, offen, total, listenpreis) {
      stickyStand = { ok: ok, frei: frei };
      if (!sticky) return;
      sticky.querySelector('.km-sticky__total').textContent = ok ? fmt(total) : '–';
      var st = sticky.querySelector('.km-sticky__streich');
      st.textContent = listenpreis > 0 ? fmt(listenpreis) : ''; st.hidden = !(listenpreis > 0);
      var b = sticky.querySelector('.km-sticky__btn');
      b.textContent = frei ? 'In den Warenkorb' : 'Weiter';
      b.classList.toggle('km-sticky__btn--cart', !!frei);
      stickySichtbarkeit();
    }

    /* ================= Warenkorb ================= */
    function msg(t, ok) { if (els.msg) { els.msg.textContent = t; els.msg.className = 'km-msg ' + (ok ? 'is-ok' : 'is-err'); els.msg.removeAttribute('data-km-auswahl'); } }
    if (els.add) els.add.addEventListener('click', function () {
      var r = update();
      if (!r.frei) {
        var ziel = naechsterOffener(null);
        msg(r.ok ? 'Bitte gehen Sie noch durch: ' + r.offen.join(', ') + '.' : 'Die Preisliste dieses Produkts ist nicht vollständig – bitte rufen Sie uns an.', false);
        if (r.ok && els.msg) els.msg.setAttribute('data-km-auswahl', '1');
        if (ziel) { schritte.forEach(function (x) { aufklappen(x, false); }); aufklappen(ziel, true, false); update(); ziel.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
      var items = [{ id: CTX.variantId, quantity: menge(), properties: properties(r.s, r.p) }];
      els.add.setAttribute('aria-busy', 'true'); msg('', true);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
        .then(function () { msg('Konfiguration im Warenkorb.', true); window.location.href = '/cart'; })
        .catch(function (e) { msg('Der Artikel konnte nicht in den Warenkorb gelegt werden: ' + e.message, false); })
        .then(function () { els.add.removeAttribute('aria-busy'); });
    });

    /* ================= Angebotsanfrage (Modal) ================= */
    (function anfrageInit() {
      var knopf = els.quote;
      var modal = document.getElementById('km-modal-' + sid);
      var anfrage = document.getElementById('km-quoteform-' + sid);
      if (!knopf || !modal || !anfrage) return;
      var zusammenfassung = document.getElementById('km-modal-konfig-' + sid);
      var fehlerfeld = document.getElementById('km-quoteerr-' + sid);
      var fertig = document.getElementById('km-quotedone-' + sid);
      var lieferBlock = document.getElementById('km-liefer-' + sid);
      var geoeffnetUm = 0, zuletztFokussiert = null, laeuft = false;

      function uebersichtHtml(r) {
        var z = [];
        for (var i = 0; i < r.p.zeilen.length; i++) { var x = r.p.zeilen[i]; if (x.leer) continue; z.push((x.schritt === 'modell' ? R.familie : x.label) + ': ' + x.value); }
        if (R.menge && menge() > 1) z.push(R.menge.label + ': ' + menge());
        return z.map(esc).join('<br>') + '<br><br><strong>' + esc(fmt(r.total) + ' inkl. MwSt.') + '</strong>';
      }
      function fokussierbare() { return modal.querySelectorAll('button:not([disabled]),a[href],input:not([type="hidden"]),select,textarea'); }
      function beiTaste(e) {
        if (e.key === 'Escape') { schliessen(); return; }
        if (e.key !== 'Tab') return;
        var f = fokussierbare(); if (!f.length) return;
        var erstes = f[0], letztes = f[f.length - 1];
        if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
        else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
      }
      function oeffnen() {
        var r = update();
        if (!r.frei) { msg(r.ok ? 'Bitte gehen Sie zuerst alle Schritte durch: ' + r.offen.join(', ') + '.' : 'Bitte prüfen Sie Ihre Konfiguration.', false); if (r.ok && els.msg) els.msg.setAttribute('data-km-auswahl', '1'); return; }
        zusammenfassung.innerHTML = uebersichtHtml(r);
        var bem = wert('bemerkung'); if (bem && !anfrage.elements['bemerkung'].value) anfrage.elements['bemerkung'].value = bem;
        if (CTX.country) { var landFeld = anfrage.elements['land']; for (var i = 0; i < landFeld.options.length; i++) if (landFeld.options[i].value === CTX.country) { landFeld.value = CTX.country; break; } }
        ustidSichtbarkeit();
        anfrage.hidden = false; fertig.hidden = true; fehlerfeld.hidden = true; modal.hidden = false;
        document.body.classList.add('km-modal-open'); document.addEventListener('keydown', beiTaste);
        geoeffnetUm = Date.now(); zuletztFokussiert = document.activeElement;
        var erstesFeld = anfrage.querySelector('input[name="vorname"]'); if (erstesFeld) erstesFeld.focus();
      }
      function schliessen() {
        modal.hidden = true; document.body.classList.remove('km-modal-open'); document.removeEventListener('keydown', beiTaste);
        if (zuletztFokussiert && zuletztFokussiert.focus) zuletztFokussiert.focus();
      }
      function fehler(text) { fehlerfeld.textContent = text; fehlerfeld.hidden = false; fehlerfeld.scrollIntoView({ block: 'nearest' }); }
      function adresse() {
        var fehlend = [];
        ['vorname', 'nachname', 'strasse', 'plz', 'ort', 'email'].forEach(function (n) { var el = anfrage.elements[n]; var leer = !String(el.value || '').trim(); el.setAttribute('aria-invalid', leer ? 'true' : 'false'); if (leer) fehlend.push(n); });
        if (fehlend.length) { fehler('Bitte füllen Sie alle Pflichtfelder aus.'); anfrage.elements[fehlend[0]].focus(); return null; }
        var mail = String(anfrage.elements['email'].value).trim();
        if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(mail)) { anfrage.elements['email'].setAttribute('aria-invalid', 'true'); fehler('Diese E-Mail-Adresse sieht nicht richtig aus. Ohne sie können wir Ihnen das Angebot nicht schicken.'); anfrage.elements['email'].focus(); return null; }
        // Kein Einwilligungs-Haken mehr (Martin 16.09.2026) - der Datenschutzhinweis steht unter dem
        // Formular. Die Nutzlast fuehrt dsgvo weiterhin als true: der n8n-Workflow bricht ohne dieses
        // Feld ab (Node "Anfrage pruefen": if (b.dsgvo !== true) throw).
        // Anrede entfaellt: der Workflow hat dafuer einen Fallback ("Guten Tag Vorname Nachname").
        function t(n) { var el = anfrage.elements[n]; return el ? String(el.value || '').trim() : ''; }
        return { firma: t('firma'), ustid: t('ustid').toUpperCase().replace(/[\s.\-]/g, ''), vorname: t('vorname'), nachname: t('nachname'), strasse: t('strasse'), plz: t('plz'), ort: t('ort'), land: t('land') || 'DE', email: mail, telefon: t('telefon'), bemerkung: t('bemerkung') };
      }
      function lieferanschrift() {
        var an = anfrage.elements['abw_lieferung']; if (!an || !an.checked) return { ok: true, wert: null };
        var fehlend = [];
        ['l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) { var el = anfrage.elements[n]; if (!el) return; var leer = !String(el.value || '').trim(); el.setAttribute('aria-invalid', leer ? 'true' : 'false'); if (leer) fehlend.push(n); });
        if (fehlend.length) { fehler('Bitte füllen Sie die Lieferanschrift vollständig aus. Ansprechpartner und Telefon brauchen wir für die Avisierung durch die Spedition.'); anfrage.elements[fehlend[0]].focus(); return { ok: false, wert: null }; }
        function lt(n) { var el = anfrage.elements[n]; return el ? String(el.value || '').trim() : ''; }
        return { ok: true, wert: { firma: lt('l_firma'), person: lt('l_person'), telefon: lt('l_telefon'), strasse: lt('l_strasse'), plz: lt('l_plz'), ort: lt('l_ort'), land: lt('l_land') || 'DE' } };
      }
      var abwFeld = anfrage.elements['abw_lieferung'];
      if (abwFeld && lieferBlock) abwFeld.addEventListener('change', function () {
        lieferBlock.hidden = !abwFeld.checked;
        if (!abwFeld.checked) ['l_firma', 'l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) { var el = anfrage.elements[n]; if (el) { el.value = ''; el.setAttribute('aria-invalid', 'false'); } });
        else { var erstes = anfrage.elements['l_person']; if (erstes) erstes.focus(); }
      });
      function ustidSichtbarkeit() {
        var feld = anfrage.querySelector('.km-fld--ustid'), landFeld = anfrage.elements['land']; if (!feld || !landFeld) return;
        var auslaendisch = landFeld.value && landFeld.value !== 'DE';
        feld.hidden = !auslaendisch; if (!auslaendisch && anfrage.elements['ustid']) anfrage.elements['ustid'].value = '';
      }
      if (anfrage.elements['land']) anfrage.elements['land'].addEventListener('change', ustidSichtbarkeit);
      knopf.addEventListener('click', oeffnen);
      // 19.09.2026: Auf Touch-Geräten gibt es kein Hover - das (i) im Knopf klappt den Hinweis
      // per Tap auf (Klasse is-tip), ohne das Angebotsfenster zu öffnen; Tipp irgendwo anders schließt.
      var info = knopf.querySelector('.km-angebot__i');
      if (info) {
        info.addEventListener('click', function (e) {
          if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;
          e.stopPropagation(); e.preventDefault();
          knopf.classList.toggle('is-tip');
        });
        document.addEventListener('click', function (e) { if (!knopf.contains(e.target)) knopf.classList.remove('is-tip'); });
      }
      modal.querySelectorAll('[data-km-close]').forEach(function (b) { b.addEventListener('click', schliessen); });
      anfrage.addEventListener('submit', function (e) {
        e.preventDefault(); if (laeuft) return; fehlerfeld.hidden = true;
        var kunde = adresse(); if (!kunde) return;
        var liefer = lieferanschrift(); if (!liefer.ok) return;
        if (!CTX.quoteEndpoint) { fehler('Die Anfrage kann gerade nicht übermittelt werden. Bitte rufen Sie uns an: +49 9672 9269 110'); return; }
        var r = update(); if (!r.frei) { fehler('Bitte prüfen Sie Ihre Konfiguration.'); return; }
        var absenden = anfrage.querySelector('button[type="submit"]');
        laeuft = true; absenden.setAttribute('aria-busy', 'true');
        // Für n8n: kompakter Zustand (konfig) plus die fertigen Auftragszeilen (merkmale) und der
        // Bruttopreis - so braucht der Angebots-Workflow für diese Familie keine eigene Preislogik.
        var merkmale = [];
        for (var i = 0; i < r.p.zeilen.length; i++) merkmale.push({ key: r.p.zeilen[i].key, value: r.p.zeilen[i].value, betrag: r.p.zeilen[i].betrag });
        var nutzlast = {
          typ: 'ausstattung', produkt_id: String(CTX.productId || ''), produkt_titel: CTX.productTitle, produkt_url: CTX.productUrl, sku: CTX.sku || '',
          hp: String(anfrage.elements['hp'].value || ''), ms: Date.now() - geoeffnetUm, dsgvo: true, kunde: kunde, lieferung: liefer.wert,
          konfig: konfig(r.s), merkmale: merkmale, preis_brutto: r.p.total, modell: r.p.modell.label, menge: menge()
        };
        fetch(CTX.quoteEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(nutzlast) })
          .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, body: j }; }); })
          .then(function (a) { if (!a.ok || a.body.ok !== true) throw new Error(a.body && a.body.grund ? a.body.grund : ''); anfrage.hidden = true; fertig.hidden = false; fertig.querySelector('button').focus(); })
          .catch(function (e) { fehler((e.message ? e.message + ' ' : 'Die Anfrage konnte nicht übermittelt werden. ') + 'Bitte versuchen Sie es noch einmal oder rufen Sie uns an: +49 9672 9269 110'); })
          .then(function () { laeuft = false; absenden.removeAttribute('aria-busy'); });
      });
    })();

    /* ================= Deep-Link lesen, Events, Start ================= */
    (function restore() {
      var m = location.hash.match(/konf=([A-Za-z0-9+\/]+)/) || location.search.match(/konf=([A-Za-z0-9+\/]+)/);
      if (!m) return;
      var c = decode(m[1]); if (!c || c.t !== 'ausstattung') return;
      // Marker w=1 setzt der Modellwechsler: die Auswahl wird uebernommen, gilt aber NICHT als
      // erledigt - Feldzahl und Preise haengen am Modell, der Kunde soll die Schritte am neuen
      // Modell noch einmal bestaetigen. Ein geteilter Link ohne Marker bleibt eine fertige
      // Konfiguration und zeigt weiter alle Haken.
      var wechsel = /[#&]w=1(?![0-9])/.test(location.hash) || /[?&]w=1(?![0-9])/.test(location.search);
      for (var i = 0; i < SCHRITTE.length; i++) { if (c[SCHRITTE[i]] !== undefined) { setWert(SCHRITTE[i], c[SCHRITTE[i]]); if (!wechsel) beruehrt[SCHRITTE[i]] = true; } }
      // Freie Eingaben (Sonderfarbe) aus dem Deep-Link zuruecklesen - sonst geht der Farbton beim Teilen verloren
      for (var wq = 0; wq < SCHRITTE.length; wq++) { var wn = SCHRITTE[wq] + '_wunsch'; if (c[wn] !== undefined) setWert(wn, c[wn]); }
      if (c.bemerkung) setWert('bemerkung', c.bemerkung);
    })();
    function schrittVon(n) { if (!n) return null; if (R[n]) return n; var i = n.indexOf('_n_'); return i > 0 && R[n.slice(0, i)] ? n.slice(0, i) : null; }
    // Karte der bereits vorgewaehlten Option (erste Option, z. B. "Freitragend") angeklickt: kein change-Event,
    // der Schritt gilt trotzdem als bewusst gewaehlt (Martin 14.10.2026)
    form.addEventListener('click', function (e) { var t = e.target; if (!t || t.type !== 'radio') return; var st = schrittVon(t.name); if (st && !beruehrt[st]) { beruehrt[st] = true; letzterSchritt = st; update(); } });
    form.addEventListener('input', function (e) { nutzerAendert = true; var st = schrittVon(e.target && e.target.name); if (st) { beruehrt[st] = true; letzterSchritt = st; } update(); });
    form.addEventListener('change', function (e) {
      nutzerAendert = true; var st = schrittVon(e.target && e.target.name); if (st) { beruehrt[st] = true; letzterSchritt = st; }
      // Hochbeet: neue Blechstaerke -> Oberkante auf das Mindestmass dieser Staerke (Verhalten des Lieferanten)
      if (FORMEL && st === 'blech' && FORMEL.ok_min) {
        var okm = FORMEL.ok_min[String(wert('blech'))];
        if (okm) { if (form.elements.oberkante_breite) form.elements.oberkante_breite.value = okm[0]; if (form.elements.oberkante_hoehe) form.elements.oberkante_hoehe.value = okm[1]; }
      }
      if (e.target && e.target.name === 'km_menge') { var mv = menge(); if (String(e.target.value) !== String(mv)) e.target.value = mv; }
      if ((st && R[st] && R[st].typ === 'mass') || FORMEL) masseKlemmen();
      update();
      galerieOption(st);
    });
    // Portal: Schnellwahl der Preisstufen (Chips unter dem Massfeld) - setzt das Feld und loest change aus
    root.querySelectorAll('[data-km-chip]').forEach(function (c) {
      c.addEventListener('click', function () {
        var step = c.getAttribute('data-km-chip-step'), mf = form.elements[step]; if (!mf) return;
        mf.value = c.getAttribute('data-km-chip'); nutzerAendert = true; beruehrt[step] = true; masseKlemmen(); update();
      });
    });
    // Klick auf den Text neben dem Zahlenfeld darf die Karte nicht abwaehlen (das Feld selbst loest das Label nicht aus)
    root.querySelectorAll('.km-card__menge').forEach(function (b) { b.addEventListener('click', function (e) { if (e.target.tagName !== 'INPUT') e.preventDefault(); }); });
    /* Modellwechsler: Reiter schalten die Kachelgruppe, Kachel-Link nimmt die aktuelle Konfiguration als #konf= mit */
    (function modellwechsler() {
      var box = root.querySelector('[data-km-modelle]'); if (!box) return;
      box.querySelectorAll('.km-modelle__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var k = tab.getAttribute('data-klasse');
          box.querySelectorAll('.km-modelle__tab').forEach(function (t) { var an = t === tab; t.classList.toggle('is-aktiv', an); t.setAttribute('aria-selected', an ? 'true' : 'false'); });
          box.querySelectorAll('.km-modelle__grid').forEach(function (g) { g.hidden = g.getAttribute('data-klasse') !== k; });
        });
      });
      box.querySelectorAll('a.km-modelle__tile[data-km-basis]').forEach(function (a) {
        a.addEventListener('click', function () {
          var basis = a.getAttribute('data-km-basis'), code = '';
          try { code = encode(state()); } catch (e) {}
          a.setAttribute('href', code ? basis + '#konf=' + code + '&w=1' : basis);
        });
      });
    })();
    miniAnlegen();
    // 19.09.2026: Groessenkarten (Festpreis je Groesse, kurze Labels) unter 560 px 2-spaltig (CSS .km-cards--kompakt)
    // Martin 19.09.2026 (nach V73): beim Vordach (Regelwerk mit Medienzuordnung) alle Einfachauswahl-Schritte
    // mobil 2 je Zeile; Köln bleibt einspaltig (lange Labels, Zubehör mit Stückzahl). Karten mit Kachelbild
    // stellen sich in der Kompaktform hochkant (CSS .km-cards--kompakt .km-card__photo).
    schritte.forEach(function (s) {
      var d = R[s.getAttribute('data-step')]; var c = s.querySelector('.km-cards'); if (!d || !c) return;
      if (d.mehrfach || c.classList.contains('km-cards--designs')) return;
      var farben = (d.optionen || []).some(function (o) { return !!o.farbe; });
      var lang = (d.optionen || []).some(function (o) { return String(o.label || '').length > 30; }); // Portal: Seitenteil-Labels bleiben einspaltig
      if ((R.medien && !lang) || d.grundpreis || farben) c.classList.add('km-cards--kompakt');
    });
    schritte.forEach(function (s) { aufklappen(s, false, false); });
    if (schritte[0]) aufklappen(schritte[0], true, false);
    update();
    renderThumbsVerstecken();
    // Beim Laden bleibt das Produktfoto stehen; das Konfigurationsbild erscheint mit der ersten Eingabe.
    galerieBereit = true; aktuellerKey = null;
    try { tiaGalerie(); } catch (e) { if (window.console) console.warn('km-ausstattung: Galerie-Kacheln', e); }
  }

  document.querySelectorAll('.km-ausstattung[data-section-id]').forEach(init);
})();
